import React from "react";
import { dispatch } from "@rematch/core";
import { push } from "react-router-redux";
import _ from "lodash";
import {
  practicesService,
  initiativeCommunitiesService,
  initiativesService,
  subOrganizationTreeService,
  publishedContentsService,
  subOrganizationService,
  initiativeActivitiesService,
  initiativeSubOrgService,
  serviceFatcory,
  invitesService,
  initiativeactivitiesDndService,
  startInitiativeService,
  initiativeLeafActivitiesService,
  activitiesGroupedByCommunitiesService,
  initiativeMemberActivitiesService,
  onHoldActivitiesService,
  initiativesCountByStatusForMemberService,
  initiativeAssociatedTeamsService,
  assignAllCommunitiesToOneTeamService,
  copyTeamStructureService,
  accountUsersService,
  accountUserWorkspacesService,
  initiativeDependenciesService,
  activityRaciusersService,
  initiativeDetailsService,
  publicPlayboooksService,
  editInitiativeService,
  restartInitiativeService,
  exportInitiativeService,
  userWorkspaceCacheService,
  copyActivityService,
  initiativeActivityActionsService
} from "../../services/feathers.service";
import { toastr } from "react-redux-toastr";
import UserCache from "../../helpers/cache/userCache";
import Graph from "../../helpers/cache/graph";
import { getUserWorkspaceCache } from "../../helpers/userCacheManager";
import { slugify } from "../../helpers/slugify";
const initialState = {
  intitiativeData: {},
  intitiativeCountData: {},
  practiceData: [],
  searchedPracticeData: [],
  selectedDataById: {},
  selectedPlaybookData: {},
  resourcePaneFlag: null,
  selectedInitiative: {},
  componentDesignerDimension: {},
  nodes: [],
  selectedPracticeFlowCommunity: {},
  suborgDetails: {},
  buttonStatus: false,
  pageNotFound: false,
  selectedActivityData: {},
  selectedParamOrganization: null,
  validateInitiativeName: false,
  RaciUserList: {},
  publishedContent: [],
  isDragable: null,
  subOrgInvitaions: [],
  isViewUserModalOpen: false,
  activeStatus: null,
  activeTab: null,
  initiativeId: null,
  isEnableDependencyOpen: false,
  arrangementPaneTab: null,
  isAddActivityModalOpen: false,
  isCopyActivityModalOpen: false,
  copyActivityLoader: false,
  isDurationSet: true,
  currentNote: {},
  currentPathValue:0,
  activityRACIUsers: [],
  associatedTeams: [],
  teamList: [],
  isAddPhaseModalOpen: false,
  newActivityObj: {
    raci: {},
  },
  addPeerBtnStatus: false,
  teamLevelDetails: {},
  milestoneDependentActivity: [],
  leafActivity: [],
  raciFilterProperties: {
    raciAllChecked: true,
    myProgressChecked: false,
    accountable: false,
    responsible: false,
    consulted: false,
    informed: false,
  },
  childCommunities:[],
  advancedFilterProperties: {
    members: [],
    roles: [],
    stateActiveChecked: false,
    stateOnHoldChecked: false,
    statusNotStartedChecked: false,
    statusCompletedChecked: false,
    statusIssueChecked: false,
    statusInProgressChecked: false,
    statusDelayedChecked: false,
    showAllRoles: false,
    serarchedRolesAvailable: false,
    searchedRoles: [],
    value: "",
    selectedUsers: [],
    userSearchValue: "",
    serarchedUsersAvailable: false,
    searchedUsers: [],
    initiativeId: null,
    

  },
  initiativeMemberActivities: {
    myActivities: [],
  },
  position: {
    containerId: null,
    rowNo: 0,
  },
  sequenceViewPosition: {
    containerId: null,
    rowNo: 0,
  },
  teamViewPosition: {
    containerId: null,
    rowNo: 0,
  },
  raciCount: {},
  initiativeOwnerDetails: {},
  setUniqueId: null,
  splitAtSize: null,
  activityActions: [],
  organizationsMap: null,
  communitiesMembersMap: null,
  allInitiativesByTeamId: [],
  allInitiativesByUserIdAndTeamId: [],
  sortingFlag: { key: "category", order: -1 },
  initiativeActivityActions: [],
  updatedActivity: null,
};

export default {
  state: initialState,
  reducers: {
    setAllInitiatives(state, payload) {
      return {
        ...state,
        intitiativeData: payload,
      };
    },
    setPosition(state, payload) {
      return {
        ...state,
        position: payload,
      };
    },
    setSequenceViewPosition(state, payload) {
      return {
        ...state,
        sequenceViewPosition: payload,
      };
    },
    setTeamViewPosition(state, payload) {
      return {
        ...state,
        teamViewPosition: payload,
      };
    },
    setInitiativeCountsData(state, payload) {
      return {
        ...state,
        intitiativeCountData: payload,
      };
    },
    setInitiativeCountsDataForMember(state, payload) {
      return {
        ...state,
        initiativeCountDataForMember: payload,
      };
    },
    setAllPracticesData(state, payload) {
      return {
        ...state,
        practiceData: payload,
      };
    },
    setSearchedPracticeData(state, payload) {
      return {
        ...state,
        searchedPracticeData: payload,
      };
    },
    setSelectedDataById(state, payload) {
      if (payload.activities) {
        let sequenceViewMap = new Map();
        payload.activities.forEach((phase) => {
          sequenceViewMap.set(phase._id, phase);
          if (phase.activities) {
            phase.activities.forEach((stage) => {
              sequenceViewMap.set(stage._id, stage);
              if (stage.activities) {
                stage.activities.forEach((activity) => {
                  sequenceViewMap.set(activity._id, activity);
                });
              }
            });
          }
        });
        payload.sequenceViewMap = sequenceViewMap;
      }

      return {
        ...state,
        selectedDataById: payload,
      };
    },
    setSelectedPlaybookData(state, payload) {
      return {
        ...state,
        selectedPlaybookData: payload,
      };
    },
    NotFound(state, payload) {
      return {
        ...state,
        pageNotFound: payload,
      };
    },
    showResourecePaneFlagSet(state, payload) {
      return {
        ...state,
        resourcePaneFlag: payload,
      };
    },
    setPublishedPractices(state, payload) {
      return {
        ...state,
        publishedPacks: payload,
      };
    },
    setcreatedInitiative(state, payload) {
      return {
        ...state,
        selectedInitiative: payload,
      };
    },
    designerDimension(state, payload) {
      return {
        ...state,
        componentDesignerDimension: payload,
      };
    },
    setSelectedCommunityData(state, payload = {}) {
      return {
        ...state,
        selectedPracticeFlowCommunity: payload,
      };
    },
    setSelectedActivityData(state, payload = {}) {
      return {
        ...state,
        selectedActivityData: payload,
      };
    },
    setSelectedInitiativeActivityActions(state, payload = {}) {
      return {
        ...state,
        initiativeActivityActions: payload,
      };
    },
    setUpdatedActivity(state, payload) {
      //console.log("payload", payload);
      return {
        ...state,
        updatedActivity: payload,
      };
    },
    setOrgUnits(state, payload) {
      return {
        ...state,
        nodes: payload,
      };
    },
    setSubOrgData(state, payload) {
      return {
        ...state,
        suborgDetails: payload,
      };
    },
    enableDisableButton(state, payload) {
      return {
        ...state,
        buttonStatus: payload,
      };
    },
    setSelectedParamOrganization(state, payload) {
      return {
        ...state,
        selectedParamOrganization: payload,
      };
    },
    isInitiativeAvailable(state, payload) {
      return {
        ...state,
        validateInitiativeName: payload,
      };
    },
    setManagerList(state, payload) {
      return {
        ...state,
        RaciUserList: payload,
      };
    },
    setContentListData(state, payload = []) {
      return {
        ...state,
        publishedContent: payload,
      };
    },
    setIsDragable(state, payload) {
      return {
        ...state,
        isDragable: payload,
      };
    },
    setInvitaionInsideSubOrg(state, payload = []) {
      return {
        ...state,
        subOrgInvitaions: payload,
      };
    },
    setviewUserModalOpen(state, payload) {
      return {
        ...state,
        isViewUserModalOpen: payload,
      };
    },
    pageStatus(state, payload) {
      return {
        ...state,
        activeStatus: payload,
      };
    },
    tabName(state, payload) {
      return {
        ...state,
        activeTab: payload,
      };
    },
    setInitId(state, payload) {
      return {
        ...state,
        initiativeId: payload,
      };
    },
    setEnableDependencyFlag(state, payload) {
      return {
        ...state,
        isEnableDependencyOpen: payload,
      };
    },
    setinitiativeAggangementPane(state, payload) {
      return {
        ...state,
        arrangementPaneTab: payload,
      };
    },
    setAddActivityModalOpen(state, payload) {
      return {
        ...state,
        isAddActivityModalOpen: payload,
      };
    },
    setCopyActivityModalOpen(state, payload) {
      return {
        ...state,
        isCopyActivityModalOpen: payload,
      };
    },
    setLoader(state, payload) {
      return {
        ...state,
        copyActivityLoader: payload,
      };
    },
    setIsDurationExist(state, payload) {
      return {
        ...state,
        isDurationSet: payload,
      };
    },
    setCurrntNotesData(state, payload) {
      return {
        ...state,
        currentNote: payload,
      };
    },
    setRACIUsers(state, payload) {
      return {
        ...state,
        activityRACIUsers: payload,
      };
    },
    setCycles(state, payload) {
      return {
        ...state,
        selectedDataById: {
          ...state.selectedDataById,
          cycles: payload,
        },
      };
    },
    setDuration(state, payload) {
      return {
        ...state,
        selectedDataById: {
          ...state.selectedDataById,
          duration: payload,
        },
      };
    },
    setWorkingDays(state, payload) {
      return {
        ...state,
        selectedDataById: {
          ...state.selectedDataById,
          workingDays: payload,
        },
      };
    },
    setStartEndDate(state, payload) {
      return {
        ...state,
        selectedDataById: {
          ...state.selectedDataById,
          startDate: payload.startDate,
          endDate: payload.endDate,
        },
      };
    },
    setActivityNodesArray(state, payload) {
      return {
        ...state,
        selectedDataById: {
          ...state.selectedDataById,
          activityNodes: payload,
        },
      };
    },
    setInitiativeMemberActivities(state, payload) {
      return {
        ...state,
        initiativeMemberActivities: payload,
      };
    },
    setGraphData(state, payload = {}) {
      return {
        ...state,
        selectedinitiativeGraph: payload,
      };
    },
    setDepnendentNodesForActivityData(state, payload) {
      return {
        ...state,
        selectedActivityData: {
          ...state.selectedActivityData,
          dependentNodes: payload,
        },
      };
    },
    setAssociatedTeams(state, payload) {
      return {
        ...state,
        associatedTeams: payload,
      };
    },
    setTeamList(state, payload) {
      return {
        ...state,
        teamList: payload,
      };
    },
    setAddPhaseModalOpen(state, payload) {
      return {
        ...state,
        isAddPhaseModalOpen: payload,
      };
    },
    setNewActivityObj(state, payload) {
      return {
        ...state,
        newActivityObj: payload,
      };
    },

    setPeerActBtnStatus(state, payload) {
      return {
        ...state,
        addPeerBtnStatus: payload,
      };
    },
    updateInitiativeCommunities(state, payload) {

      return {
        ...state,
        selectedDataById: {
          ...state.selectedDataById,
          communities: payload,
          communitiesFetched: true,
        },
      };
    },

    setTeamDetails(state, payload) {
      return {
        ...state,
        teamLevelDetails: payload,
      };
    },
    setDependetMilestoneData(state, payload) {
      return {
        ...state,
        milestoneDependentActivity: payload,
      };
    },
    setLeafActData(state, payload) {
      return {
        ...state,
        leafActivity: payload,
      };
    },
    setRACIFilterProperties(state, payload) {
      return {
        ...state,
        raciFilterProperties: payload,
      };
    },
    setAdvancedFilterProperties(state, payload) {
      return {
        ...state,
        advancedFilterProperties: payload,
      };
    },
    setRACICount(state, payload) {
      return {
        ...state,
        raciCount: payload,
      };
    },
    setInitiativeOwnerDetails(state, payload) {
      return {
        ...state,
        initiativeOwnerDetails: payload,
      };
    },
    setPlaybookOwnerDetails(state, payload) {
      return {
        ...state,
        playbookOwnerDetails: payload,
      };
    },
    setDBUniqueId(state, payload) {
      return {
        ...state,
        setUniqueId: payload,
      };
    },
    setSplitAtSize(state, payload) {
      return {
        ...state,
        splitAtSize: payload,
      };
    },
    setChildCommunities(state, payload) {
      return {
        ...state,
        childCommunities: payload,
      };
    },
    setInitiativeExecutionTeam(state, payload) {
      return {
        ...state,
        childCommunities: payload,
      };
    },
    addActivityAction(state, payload = {}) {
      return {
        ...state,
        activityActions: [...state.activityActions, payload],
      };
    },
    clearActivityActions(state) {
      return {
        ...state,
        activityActions: [],
      };
    },
    removeItemFromActivityAction(state, payload) {
      return {
        ...state,
        activityActions: [
          ...state.activityActions.slice(0, payload),
          ...state.activityActions.slice(payload + 1),
        ],
      };
    },
    setInitiativeError(state, payload) {
      return {
        ...state,
        initiativeError: payload,
      };
    },
    setOrganizationMap(state, payload) {
      return {
        ...state,
        organizationsMap: payload,
      };
    },
    setCommunitiesMembersMap(state, payload) {
      return {
        ...state,
        communitiesMembersMap: payload,
      };
    },
    setTeamViewMap(state, payload) {
      return {
        ...state,
        selectedDataById: {
          ...state.selectedDataById,
          teamViewMap: payload,
        },
      };
    },
    setInitiativesByTeamId(state, payload) {
      return {
        ...state,
        allInitiativesByTeamId: payload,
      };
    },
    setInitiativesByUserIdAndTeamId(state, payload) {
      return {
        ...state,
        allInitiativesByUserIdAndTeamId: payload,
      };
    },
    isSortingFlag(state, payload) {
      return {
        ...state,
        sortingFlag: payload,
      };
    },
    clear() {
      return initialState;
    },
    treeCurrentPath(state, payload) {
      return {
        ...state,
        currentPathValue: payload,
      };
    },
  },

  effects: {
    clearAsync() {
      dispatch.lifeCycle.clear();
    },
    // Get all initiative List
    async getInitiatives(payload) {
      let query = {
        organizationId: payload.organizationId,
        accountId: payload.accountId,
        string: "initiatives",
      };
      if (payload.status) {
        query.status = payload.status;
      }

      let intiatives = await initiativesService.find({
        query: query,
      });
      if (intiatives && intiatives.data && intiatives.data.length !== 0) {
        for (let i = 0; i < intiatives.data.length; i++) {
          if (
            intiatives.data[i].status === 1 ||
            intiatives.data[i].status === 2 ||
            intiatives.data[i].status === 4
          ) {
            intiatives.data[i].combineActiveStatus = 1;
          } else {
            intiatives.data[i].combineActiveStatus = intiatives.data[i].status;
          }
        }
      }

      intiatives.data
        .sort(
          (d1, d2) =>
            new Date(d1.createdAt).getTime() - new Date(d2.createdAt).getTime()
        )
        .reverse();

      dispatch.initiatives.setAllInitiatives(intiatives);

      if (payload.sortBy && payload.sortBy.key) {
        dispatch.initiatives.isSortingFlag(payload.sortBy);
      }
    },
    // Get all initiative List
    async getinitiativesCount(payload, state) {
      if (
        payload.organizationId &&
        state.app.selectedOrganisation &&
        state.app.selectedOrganisation.id &&
        payload.organizationId.toString() ===
          state.app.selectedOrganisation.id.toString()
      ) {
        const initiativesByOrgService = serviceFatcory.getProxy(
          `/organizations/initiatives/summary`
        );
        const intiativesSummary = await initiativesByOrgService.get(
          payload.organizationId,
          { query: payload }
        );
        dispatch.initiatives.setInitiativeCountsData(intiativesSummary);
      }
    },
    async getinitiativesCountProxy(payload) {
      await dispatch.initiatives.getinitiativesCount(payload);
    },
    // Get all Publish Practices
    async getPublishedPractices(payload) {
      const publishedPractices = await publicPlayboooksService.find({
        query: {
          $or: [
            { organizationId: payload.organizationId },
            { scope: "Public" },
          ],
          status: 4,
        },
      });
      dispatch.initiatives.setAllPracticesData(publishedPractices);
      dispatch.initiatives.setSearchedPracticeData(publishedPractices);
    },

    setTreeCurrentPath(payload) {
      dispatch.initiatives.treeCurrentPath(payload);
    },
    

    async getPracticeById(payload) {
      const practices = await practicesService.get(payload, {
        query: {
          $populate: [
            {
              path: "baseCategory",
              populate: "baseCategory",
              select: "_id name",
            },
            { path: "category", populate: "category", select: "_id name" },
            {
              path: "subCategory",
              populate: "subCategory",
              select: "_id name",
            },
          ],
        },
      });
      dispatch.initiatives.setSelectedPlaybookData(practices);
      dispatch.initiatives.getPlaybookOwnerDetails(practices.createdBy);
    },

    async searchPractices(payload) {
      let searchQuery = {};
      payload.name = payload.name.replace(".", "\\.");
      payload.name = payload.name.replace("*", "\\*");
      payload.name = payload.name.replace("$", "\\$");
      payload.name = payload.name.replace("&", "\\&");
      searchQuery = {
        $and: [
          { status: 4 },
          {
            $or: [
              { name: { $regex: payload.name, $options: "i" } },
              { tags: { $elemMatch: { $regex: payload.name, $options: "i" } } },
            ],
          },
          {
            $or: [
              { organizationId: payload.organizationId },
              { scope: "Public" },
            ],
          },
        ],
      };
      if (payload.baseCategory) {
        searchQuery.$and.push({ baseCategory: payload.baseCategory });
      }
      if (payload.category) {
        searchQuery.$and.push({ category: payload.category });
      }
      if (payload.scope) {
        searchQuery.$and.push({ scope: payload.scope });
      }
      let searchedPractices = await publicPlayboooksService.find({
        query: searchQuery,
      });
      dispatch.initiatives.setSearchedPracticeData(searchedPractices);
    },

    updatePracticeData(payload) {
      dispatch.initiatives.setSelectedDataById(payload);
    },
    async createInitiative(payload) {
      try {
        const createdInitData = await initiativesService.create(payload);
        toastr.success("Message", "Initiative created successfully");
        await dispatch.initiatives.getInDesignInitiativeDetailsById(
          createdInitData._id
        );
        let metaRoute = payload.isMetaAvailable
          ? "addAdditionalInfo"
          : "teamMapping";
        await dispatch.initiatives.setcreatedInitiative(payload);
        return dispatch(
          push(
            "/app/" +
              payload.accountId +
              "/_ws/" +
              payload.organizationId +
              "/_in/indesign/" +
              metaRoute +
              "/" +
              createdInitData._id
          )
        );
      } catch (err) {
        if (err.code === 409) {
          toastr.error("Message", "Initiative with same name already exists.");
        }
        if (err.message === 'GeneralError: Create initiative for this playbook is turned off'){
          toastr.error("Message", "Create initiative for this playbook is turned off.");
        }
      }
    },
    setSelectedInitiative(payload) {
      dispatch.initiatives.setcreatedInitiative(payload);
    },
    async updateInitiativeChecklist(payload,state){
      try {
        await initiativeActivitiesService.patch(
          payload.id,
          payload.updateElement,
          {
            accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
            organizationId: state.initiatives.selectedDataById.organizationId, //KLM-9017
          },
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );

      } catch (e) {
        throw e;
      }
    },
    async updateInitiativeBySpecificFields(payload, state) {
      // Below changes for KLM-9010
      try {
        let updateRecord = {};
        for (let key of Object.keys(payload)) {
          if (key !== "_id") {
            updateRecord[key] = payload[key];
          }
        }
        if (payload._id) {
          await initiativesService.patch(
            payload._id,
            {
              $set: updateRecord,
              accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
              organizationId: state.initiatives.selectedDataById.organizationId, // KLM-9017
            },
            {
              query: {
                $populate: [
                  {
                    path: "attachments.uploadedBy",
                    populate: "uploadedBy",
                    select: "_id firstName lastName profilePic ",
                  },
                  {
                    path: "notes.accountUserId",
                    populate: "accountUserId",
                    select: "_id firstName lastName profilePic email ",
                  },
                  {
                    path: "initativeLogs.accountUserId",
                    populate: "accountUserId",
                    select: "_id firstName lastName profilePic",
                  },
                  {
                    path: "baseCategory",
                    populate: "baseCategory",
                    select: "_id name",
                  },
                  {
                    path: "category",
                    populate: "category",
                    select: "_id name",
                  },
                  {
                    path: "subCategory",
                    populate: "subCategory",
                    select: "_id name",
                  },
                ],
              },
            }
          );
          dispatch.initiatives.updateSelectedDataById(payload);
          dispatch.initiatives.setInitiativeError(null);
        }
      } catch (e) {
        let errMessage = null;
        if (e.message.indexOf("already exists") !== -1) {
          errMessage = "Initiative with same name already exists.";
        } else {
          errMessage = "Error while updating Initiative.";
        }
        dispatch.initiatives.setInitiativeError(errMessage);
      }
    },
    async updateInitiative(payload, state) {
      try {
        await initiativesService.patch(
          payload.id,
          {
            $set:payload,
            accountId: state.initiatives.selectedDataById.accountId,
            organizationId: state.initiatives.selectedDataById.organizationId,
          },
          {
            query: {
              $populate: [
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "baseCategory",
                  populate: "baseCategory",
                  select: "_id name",
                },
                {
                  path: "initativeLogs.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic",
                },
                { path: "category", populate: "category", select: "_id name" },
                {
                  path: "subCategory",
                  populate: "subCategory",
                  select: "_id name",
                },
              ],
            },
          }
        );
      } catch (err) {
        if (err.code === 409) {
          toastr.error("Message", "Initiative with same name already exists.");
        }
      }
    },
    setDesignerDimension(payload) {
      dispatch.initiatives.designerDimension(payload);
    },
    showResourecePane(payload) {
      dispatch.initiatives.showResourecePaneFlagSet(payload);
    },
    setButtonAsDisabled(payload) {
      dispatch.initiatives.enableDisableButton(payload);
    },
    async removeInitiative(payload, state) {
      try {
        await initiativesService.remove(payload.initId, {
          query: { organizationId: payload.organizationId },
        });
        toastr.success("Message", "Initiative deleted successfully");
        dispatch.initiatives.getInitiatives(payload);
        dispatch.initiatives.getinitiativesCount(payload);
        dispatch.initiatives.showResourecePaneFlagSet(null);
        dispatch.initiatives.setSelectedDataById({});
        dispatch.initiatives.initiativeAggangementPane(null);
        if (
          state.initiatives.activeTab &&
          state.initiatives.activeTab != "ActiveInitiative"
        ) {
          return dispatch(
            push(
              "/app/" +
                payload.accountId +
                "/_ws/" +
                payload.organizationId +
                "/_in/indesign"
            )
          );
        }
      } catch (err) {
        throw err;
      }
    },

    async getInDesignInitiativeDetailsById(payload, state) {
      const userCacheObject = await userWorkspaceCacheService.get(
        state.app.selectedOrganisation.id
      );
      dispatch.app.setUserCache(userCacheObject.obj);
      const userCache = Graph.fromObject(userCacheObject.obj);
      if (userCache.hasVertex(payload)) {
        try {
          const initiative = await initiativesService.get(payload, {
            query: {
              $populate: [
                {
                  path: "practiceId",
                  populate: "practiceId",
                  select: "_id metaDataSchema",
                },
              ],
            },
          });
          await dispatch.initiatives.setSelectedDataById(initiative);
          dispatch.lifeCycle.getActivities({
            organizationId: initiative.organizationId,
            baseCategory: initiative.baseCategory,
            category: initiative.category,
            subCategory: initiative.subCategory,
            practiceId: initiative.practiceId,
          });
          if (state.createPack.publishedContent.length === 0) {
            dispatch.initiatives.getPublishedContentDataAsync({
              organizationId: initiative.organizationId,
              baseCategory: initiative.baseCategory,
            });
          }
          return;
        } catch (err) {
          if (err.code === 400 || err.code === 404 || err.code === 500) {
            return dispatch(push(`/app/${state.app.selectedAccount._id}/404`));
          }
        }
      } else {
        return dispatch(push(`/app/${state.app.selectedAccount._id}/403`));
      }
    },

    async getActiveInitiativeDetailsById(payload, state) {
      //let userCache = await getUserWorkspaceCache(state.app.selectedOrganisation._id);
      const userCache = new UserCache(state.app.userCache);
      if (
        userCache
          .getCacheObj()
          .hasVertex(payload.initiativeId ? payload.initiativeId : payload) ||
        payload.isMemberView
      ) {
        try {
          const initiative = await initiativeDetailsService.get(
            payload.initiativeId ? payload.initiativeId : payload,
            {
              query: {
                filterProperties: {
                  raciAllChecked:
                    state.initiatives.raciFilterProperties.raciAllChecked,
                  accountable:
                    state.initiatives.raciFilterProperties.accountable,
                  responsible:
                    state.initiatives.raciFilterProperties.responsible,
                  consulted: state.initiatives.raciFilterProperties.consulted,
                  informed: state.initiatives.raciFilterProperties.informed,
                  roles: state.initiatives.advancedFilterProperties.roles,
                  stateActiveChecked:
                    state.initiatives.advancedFilterProperties
                      .stateActiveChecked,
                  stateOnHoldChecked:
                    state.initiatives.advancedFilterProperties
                      .stateOnHoldChecked,
                  statusNotStartedChecked:
                    state.initiatives.advancedFilterProperties
                      .statusNotStartedChecked,
                  statusCompletedChecked:
                    state.initiatives.advancedFilterProperties
                      .statusCompletedChecked,
                  statusIssueChecked:
                    state.initiatives.advancedFilterProperties
                      .statusIssueChecked,
                  statusInProgressChecked:
                    state.initiatives.advancedFilterProperties
                      .statusInProgressChecked,
                  statusDelayedChecked:
                    state.initiatives.advancedFilterProperties
                      .statusDelayedChecked,
                  selectedUsers:
                    state.initiatives.advancedFilterProperties.selectedUsers,
                },
              },
            }
          );
          dispatch.initiatives.setSelectedDataById(initiative);
          let sequenceViewMap = new Map();
          initiative.activities.forEach((phase) => {
            sequenceViewMap.set(phase._id, phase);
            phase.activities.forEach((stage) => {
              sequenceViewMap.set(stage._id, stage);
              stage.activities &&
                stage.activities.forEach((activity) => {
                  sequenceViewMap.set(activity._id, activity);
                });
            });
          });
        } catch (err) {
          if (err.code === 400 || err.code === 404 || err.code === 500) {
            return dispatch(push(`/app/${state.app.selectedAccount._id}/404`));
          }
          throw err;
        }
      } else {
        try {
          await initiativeDetailsService.get(
            payload.initiativeId ? payload.initiativeId : payload,
            {}
          );
          return dispatch(push(`/app/${state.app.selectedAccount._id}/403`));
        } catch (err) {
          if (err.code === 400 || err.code === 404 || err.code === 500) {
            return dispatch(push(`/app/${state.app.selectedAccount._id}/404`));
          }
          throw err;
        }
      }
    },
    async checkInitiatuiveAvailability(payload, state) {
      try {
        const initiativeData = await initiativeDetailsService.get(payload.id);
        if (state.home.redirectFromDashboard && initiativeData) {
          if (initiativeData.status === 0) {
            dispatch.initiatives.showResourecePane(null);
            await dispatch(
              push(
                "/app/" +
                  state.app.selectedAccount._id +
                  "/_ws/" +
                  state.app.selectedOrganisation.id +
                  "/_in/indesign/basicInfo/" +
                  payload.id
              )
            );
            await dispatch.initiatives.getInDesignInitiativeDetailsById(
              payload.id
            );
          } else if (
            initiativeData.status === 1 ||
            initiativeData.status === 2
          ) {
            await dispatch(
              push(
                `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_in`
              )
            );
            await dispatch.initiatives.getActiveInitiativeDetailsById(
              payload.id
            );
            dispatch.initiatives.showResourecePane("ActiveInitiative");
            dispatch.initiatives.initiativeAggangementPane(
              "ActiveInitiativeTabs"
            );
            dispatch.app.setCollapsedResourcePaneIndexTemp(null);
          } else if (initiativeData.status === 5) {
            await dispatch(
              push(
                `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_in`
              )
            );
            await dispatch.initiatives.getActiveInitiativeDetailsById(
              payload.id
            );
            dispatch.initiatives.showResourecePane("CompletedInitiatives");
            dispatch.initiatives.initiativeAggangementPane(
              "ActiveInitiativeTabs"
            );
            dispatch.app.setCollapsedResourcePaneIndexTemp(null);
          } else if (initiativeData.status === 3) {
            await dispatch(
              push(
                `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_in`
              )
            );
            await dispatch.initiatives.getActiveInitiativeDetailsById(
              payload.id
            );
            dispatch.initiatives.showResourecePane("CompletedInitiatives");
            dispatch.initiatives.initiativeAggangementPane(
              "ActiveInitiativeTabs"
            );
            dispatch.app.setCollapsedResourcePaneIndexTemp(null);
          } else if (initiativeData.status === 4) {
            let initiativeID = initiativeData.copyId
              ? initiativeData.copyId
              : initiativeData._id;
            dispatch.app.setCollapsedResourcePaneIndexTemp(null);
            if (
              state.app.selectedOrganisation &&
              state.app.selectedOrganisation.role === "Manager" &&
              payload.data.createdBy.id == state.app.user._id
            ) {
              await dispatch(
                push(
                  `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_in/indesign/teamMapping/${initiativeID}`
                )
              );
            } else if (
              state.app.selectedOrganisation &&
              state.app.selectedOrganisation.role === "workspaceOwner"
            ) {
              await dispatch(
                push(
                  `/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_in/indesign/teamMapping/${initiativeID}`
                )
              );
            } else {
              dispatch.home.eventDetailsNotFound(true);
            }
          }
          dispatch.initiatives.setSelectedActivityData({});
          dispatch.initiatives.setIdToCenterPosition(payload.id);
          dispatch.initiatives.splitAt("60%");
          dispatch.initiatives.setInitiativeError(null);
        }
      } catch (e) {
        if (state.home.redirectFromDashboard) {
          dispatch.home.eventDetailsNotFound(true);
        }
      }
    },
    async getAssociatedTeam(payload) {
      try {
        // :Service to fetch all associated teams for initiative
        const associatedTeams = await initiativeAssociatedTeamsService.find({
          query: payload,
        });
        dispatch.initiatives.setAssociatedTeams(associatedTeams);
      } catch (err) {
        if (err.code === 400 || err.code === 404 || err.code === 500) {
          dispatch.initiatives.NotFound(true);
        }
      }
    },

    async getSelectedCommunityAsync(payload) {
      const communityData = await initiativeCommunitiesService.get(payload);
      dispatch.initiatives.setSelectedCommunityData(communityData);
    },
    async getTeamManagersData(payload, state) {
      let map = new Map();
      const traverseTeams = function (teams) {
        teams.forEach((team) => {
          map.set(team._id, team);
          if (
            team.parentOrganizationId &&
            state.app.selectedOrganisation &&
            team.parentOrganizationId !== state.app.selectedOrganisation.id
          ) {
            let parentObject = map.get(team.parentOrganizationId);
            if (parentObject) team.parents = parentObject.parents;
          }
          if (team.parents) {
            team.parents = `${team.parents} > ${team.label}`;
          } else {
            team.parents = `${team.label}`;
          }

          if (team.nodes && team.nodes.length > 0) {
            traverseTeams(team.nodes);
          }
        });
      };
      let communitiesMembersMap = new Map();
      const traverseSubCommunities = (communities) => {
        for (const community of communities) {
          for (const subCommunity of community.communities) {
            if (subCommunity.associatedTeam) {
              if(map.get(subCommunity.associatedTeam) && map.get(subCommunity.associatedTeam)){
                let members = map.get(subCommunity.associatedTeam).members;
                communitiesMembersMap.set(
                  subCommunity._id,
                  members
                );
              }
            }
          }
        }
      };
      const orgUnits = await subOrganizationTreeService.get(
        payload.organizationId,
        { query: { teamId: payload.teamId, isTeamMapping: true } }
      );
      if (state.initiatives.selectedDataById) {
        traverseTeams(orgUnits);
        await traverseSubCommunities(
          state.initiatives.selectedDataById.communities
        );
        dispatch.initiatives.setCommunitiesMembersMap(communitiesMembersMap);
      }
    },
    async getTeamMappingData(payload, state) {
      let map = new Map();


      const traverseTeams = function (teams) {
        teams.forEach((team) => {
          map.set(team._id, team);
          if (
            team.parentOrganizationId &&
            state.app.selectedOrganisation &&
            team.parentOrganizationId !== state.app.selectedOrganisation.id
          ) {
            let parentObject = map.get(team.parentOrganizationId);
            if (parentObject) team.parents = parentObject.parents;
          }
          if (team.parents) {
            team.parents = `${team.parents} > ${team.label}`;
          } else {
            team.parents = `${team.label}`;
          }

          if (team.nodes && team.nodes.length > 0) {
            traverseTeams(team.nodes);
          }
        });
      };
      const updateTeam = function (subCommunity, teams) {
        let teamObject = map.get(subCommunity.associatedTeam);
        if(!teamObject){
          teamObject = {};
          teamObject.associatedCommunity = [];
        } 
        if(!teamObject.associatedCommunity){
          teamObject.associatedCommunity = [];
        }
        teamObject.associatedCommunity.push(subCommunity);
      };
      const getTeammapping = function (teams = [], initiative) {
        map = new Map();
        traverseTeams(teams);
        if (initiative) {
          initiative.communities &&
            initiative.communities.forEach((community) => {
              community.communities.forEach((subCommunity) => {
                if (subCommunity.associatedTeam)
                  updateTeam(subCommunity, teams);
              });
            });
          payload.stopProcessing();
          return teams;
        }
      };
      try {
        const orgUnits = await subOrganizationTreeService.get(
          payload.organizationId,
          { query: { teamId: payload.teamId, isTeamMapping: true } }
        );

        if (state.initiatives.selectedDataById && orgUnits.length > 0) {
          let mappedOrgUnits = getTeammapping(
            orgUnits,
            state.initiatives.selectedDataById
          );
          dispatch.initiatives.dispatchOrgUnits(mappedOrgUnits);
          dispatch.initiatives.setOrganizationMap(map);
        }
        return;
      } catch (err) {
        throw err;
      }
    },

    dispatchOrgUnits(payload) {
      dispatch.initiatives.setOrgUnits(payload);
    },
    async getSuborgDetailsById(payload) {
      const suborgData = await subOrganizationService.find({
        query: {
          _id: payload,
          $populate: [
            {
              path: "members.accountUserId",
              populate: "accountUserId",
              select: "_id firstName lastName profilePic email organizations",
            },
          ],
        },
      });
      dispatch.initiatives.setSubOrgData(suborgData);
    },
    setSuborganizationData(payload) {
      dispatch.initiatives.setSubOrgData(payload);
    },
    async getSelectedActivityDetails(payload, state) {
      try {
        if (payload) {
          const activityData = await initiativeActivitiesService.get(payload, {
            query: {
              $populate: [
                {
                  path: "notes.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "onHoldComments.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "issueLogComments.accountUserId",
                  populate: "accountUserId",
                  select: "_id firstName lastName profilePic email ",
                },
                {
                  path: "attachments.uploadedBy",
                  populate: "uploadedBy",
                  select: "_id firstName lastName profilePic ",
                },
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath createdBy type deleted",
                  populate: [
                    {
                      path: "createdBy",
                      populate: "createdBy",
                      select: "_id firstName lastName profilePic ",
                    },
                  ],
                },
                {
                  path: "parentActivity",
                  populate: "parentActivity",
                  select:
                    "_id name references parentActivity isLeafNode isParentNode",
                  populate: [
                    {
                      path: "references.id",
                      populate: "contentData",
                      select: "_id name scope contentpath type deleted",
                      populate: [
                        {
                          path: "createdBy",
                          populate: "createdBy",
                          select: "_id firstName lastName profilePic ",
                        },
                      ],
                    },
                    {
                      path: "parentActivity",
                      populate: "parentActivity",
                      select: "_id name references isLeafNode isParentNode",
                      populate: [
                        {
                          path: "references.id",
                          populate: "contentData",
                          select: "_id name scope contentpath type deleted",
                          populate: [
                            {
                              path: "createdBy",
                              populate: "createdBy",
                              select: "_id firstName lastName profilePic ",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                { path: 'originalId', select: '_id name metaDataSchema'},
                {
                  path: "initiativeId",
                  model: "initiatives",
                  populate: [
                    {
                      path: "communities",
                      model: "initiativecommunities",
                      populate: [
                        {
                          path: "communities",
                          model: "initiativecommunities",
                        },
                      ],
                    },
                    {
                      path: "activities",
                      model: "initiativeactivities",
                      populate: [
                        {
                          path: "activities",
                          model: "initiativeactivities",
                          populate: [
                            {
                              path: "activities",
                              model: "initiativeactivities",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      path: "createdBy",
                      model: "accountUsers",
                      select: "firstName lastName profilePic",
                    },
                    {
                      path: "organizationId",
                      model: "organizations",
                      select: "name",
                    },
                    {
                      path: "teamId",
                      model: "suborganizations",
                      select: "name",
                    },
                  ],
                },
              ],
            },
          });

          dispatch.initiatives.clearActivityActions();
          if (state.initiatives.activeTab === "myactivities") {
            activityData &&
              activityData.initiativeId &&
              activityData.initiativeId.category &&
              dispatch.initiatives.getPublishedContentDataAsync({
                organizationId: activityData.organizationId,
                category: activityData.initiativeId.category,
              });
          }
          dispatch.initiatives.setSelectedActivityData(activityData);
          this.getSelectedInitiativeActivityActions(payload);
        } else {
          dispatch.initiatives.setSelectedActivityData({});
        }
      } catch (e) {
        throw e;
      }
    },
    async getSelectedInitiativeActivityActions(payload, state) {
      let initiativeActivityActions = await initiativeActivityActionsService.find({
        query: {
          "activityId": payload,
          $populate: [{
              path: "createdBy",
              populate: "createdBy",
              select: "_id firstName lastName profilePic email ",
            }
          ]
        }
      });
      dispatch.initiatives.setSelectedInitiativeActivityActions(initiativeActivityActions);
      return true;
    },
    selectedOrganizationFromParam(payload) {
      dispatch.initiatives.setSelectedParamOrganization(payload);
    },
    async mapCommunity(payload) {
      await initiativeCommunitiesService.patch(payload.communityId, {
        $set: {
          associatedTeam: payload.teamId,
          accountable: payload.accountable.accountUserId,
        },
        isTeamMapping: true,
        option: 1,
      });
      dispatch.initiatives.updateCommunity({
        communityId: payload.communityId,
        teamId: payload.teamId,
        accountable: payload.accountable,
        initiativeId: payload.initiativeId,
      });
      return;
    },
    async updateInitiativeActivities(payload, state) {
      // Below changes for KLM-9010
      payload.triggerEvent = true;
      try {
        await initiativeActivitiesService.patch(
          payload._id,
          payload,
          {
            accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
            organizationId: state.initiatives.selectedDataById.organizationId, //KLM-9017
          },
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );
      //  await dispatch.initiatives.getActiveInitiativeDetailsById(
      //     payload.initiativeId._id
      //   );
      } catch (e) {
        console.log("Error in updateInitiativeActivities ",e)
        // dispatch.initiatives.getActiveInitiativeDetailsById(
        //   payload.initiativeId._id
        // );
      }
    },
    setRACIObject(payload) {
      dispatch.initiatives.setRaciObjectOfselectedActivity(payload);
    },
    async updateInitiativeActivity(payload, state) {
      payload.triggerEvent = true;
      payload.raciUpdated = true;
      payload.activityActions = state.initiatives.activityActions;
      try {
        await initiativeActivitiesService.patch(
          payload._id,
          payload,
          {
            accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
            organizationId: state.initiatives.selectedDataById.organizationId, // KLM-9017
          },
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );

        if (payload.applyChangesOnChildren) {
          toastr.success("Message", "RACI propagated successfully");
        }
      } catch (err) {
        throw err;
      }
    },
    async updateMemberActivities(payload, state) {
      payload.triggerEvent = true;

      if (
        payload.completeActivitystring !== "MarkAsComplete" &&
        payload.string !== "PutOnHold" &&
        payload.string !== "ActivatePutOnHold" &&
        payload.string !== "reopenActivity"
      ) {
        dispatch.initiatives.updateActivityInMyActivities(payload);
      }
      try {
        await initiativeActivitiesService.patch(
          payload._id,
          payload,
          {
            accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
            organizationId: state.initiatives.selectedDataById.organizationId, // KLM-9017
          },
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );
      } catch (e) {
        dispatch.initiatives.updateActivityInMyActivities(payload);
      }
      await dispatch.initiatives.getSelectedActivityDetails(payload._id);
    },
    async searchInitiativeByName(payload) {
      let searchQuery = {};
      searchQuery.slug = slugify(payload.name);
      searchQuery.organizationId = payload.organizationId;
      if (payload._id) {
        searchQuery._id = { $ne: payload._id };
      }
      let searchedInitiative = await initiativesService.find({
        query: searchQuery,
      });
      if (searchedInitiative.total > 0) {
        dispatch.initiatives.isInitiativeAvailable(true);
      } else {
        dispatch.initiatives.isInitiativeAvailable(false);
      }
    },
    async getManagersBySuborgId(payload) {
      dispatch.initiatives.setManagerList(null);
      const managerList = await accountUserWorkspacesService.find({
        query: {
          subOrganizations: {
            $elemMatch: {
              id: payload,
            },
          },
          $select: ["accountUserId"],
          $populate: [
            {
              path: "accountUserId",
              populate: "accountUserId",
              select: "_id firstName lastName profilePic email isApiUser",
            },
          ],
        },
      });
      dispatch.initiatives.setManagerList(managerList);
    },
    async addSubOrganization(payload, state) {
      try {
        let createdSubOrg = await subOrganizationService.create(payload.data);
        await dispatch.initiatives.mapCommunity({
          communityId: payload.communityId,
          teamId: createdSubOrg._id,
          accountable: { accountUserId: state.app.user._id, ...state.app.user },
          initiativeId: payload.initiativeId,
        });
        return createdSubOrg._id;
      } catch (e) {
        if (e.code === 409) {
          toastr.error("Message", "Team with same name already exists");
        } else {
          toastr.error("Message", "Error while creating team");
        }
      }
    },
    async addSubOrganizationWithChild(payload) {
      try {
        await initiativeSubOrgService.create(payload);
        await dispatch.initiatives.getInDesignInitiativeDetailsById(
          payload.initiativeId
        );
      } catch (e) {
        if (e.code === 409) {
          toastr.error("Message", "Team with same name already exists");
        } else {
          toastr.error("Message", "Error while creating team");
        }
      }

      return;
    },
    async getPublishedContentDataAsync(payload, rootState) {
      //added to fix KLM-2030
      //this is a band-aid, we need to find better answer for this
      if (!rootState.login.loggedIn) {
        return;
      }
      try {
        let query = {
          $and: [],
          $limit:  payload.limit ? payload.limit : 10,
        };
        if (payload.referencesIdsArr) {
          query.$and.push({
            _id: {
              $nin: payload.referencesIdsArr,
            },
          });
        }

        if (payload.baseCategory) {
          query.$and.push({ baseCategory: payload.baseCategory });
        }
        if (payload.category) {
          query.$and.push({ category: payload.category });
        }
        if (payload.subCategory) {
          query.$and.push({ subCategory: payload.subCategory });
        }
        if (payload.scope) {
          query.$and.push({ scope: payload.scope });
        }
        if (payload.name) {
          query.$and.push({ name: { $regex: payload.name, $options: "i" } });
        }

        const contentData = await publishedContentsService.find({
          query: query,
        });

        dispatch.createPack.setContentList(contentData);
      } catch (err) {
        throw err;
      }
    },
    setContentList(payload) {
      dispatch.createPack.setContentListData(payload);
    },
    setIsDragableFlag(payload) {
      dispatch.initiatives.setIsDragable(payload);
    },
    async editActivityAsync(payload, state) {
      payload.triggerEvent = true;
      const editActivity = payload;
      try {
        await initiativeActivitiesService.patch(
          editActivity._id,
          editActivity,
          {
            accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
            organizationId: state.initiatives.selectedDataById.organizationId, // KLM-9017
          },
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );
        let payloadObj = {};
        payloadObj.activityid = payload._id;
      } catch (err) {
        dispatch.createPack.setError(err);
        toastr.error("Message", "Failed to update ");
        throw err;
      }
    },

    async getInviteBySubOrgAsync(payload) {
      try {
        const InviteData = await invitesService.find({
          query: {
            referenceId: payload,
            referenceCollection: "suborganizations",
            isAccepted: false,
            isDeclined: false,
          },
        });
        dispatch.initiatives.setInvitaionInsideSubOrg(InviteData.data);
      } catch (err) {
        toastr.error("Message", "fail to get the Invitaions");
        throw err;
      }
    },
    viewUserModalOpen(onOffState) {
      dispatch.initiatives.setviewUserModalOpen(onOffState);
    },

    setPageStatus(payload) {
      dispatch.initiatives.pageStatus(payload);
    },
    setTabName(payload) {
      dispatch.initiatives.tabName(payload);
    },
    setInitiativeId(payload) {
      dispatch.initiatives.setInitId(payload);
    },
    setEnableDependencyFlagOpen(onOffState) {
      dispatch.initiatives.setEnableDependencyFlag(onOffState);
    },

    async createActivity(payload) {
      try {
        payload.type = "add";
        await initiativeActivitiesService.create(payload);
        dispatch.initiatives.addPhaseModalOpen(false);
        dispatch.initiatives.setNewActivityObj({});
        return;
      } catch (err) {
        if (err.message.indexOf("already exists") !== -1) {
          toastr.error("Message", "Activity with same name already exists.");
        } else {
          toastr.error("Message", "Error adding activity");
        }
        throw err;
      }
    },
    async updateActivity(payload, state) {
      try {
        dispatch.initiatives.updateActivityInSelectedDataById(payload);
        const updateOldActivity = await initiativeActivitiesService.patch(
          payload.id,
          {
            name: payload.name,
            triggerEvent: true,
            accountId: state.initiatives.selectedDataById.accountId, // KLM-9020
            organizationId: state.initiatives.selectedDataById.organizationId, // KLM-9020
          },
          {
            query: {
              $populate: [
                {
                  path: "references.id",
                  populate: "contentData",
                  select: "_id name scope contentpath type",
                },
              ],
            },
          }
        );

        dispatch.initiatives.setSelectedActivityData(updateOldActivity);
      } catch (err) {
        if (err.message.indexOf("already exists") !== -1) {
          toastr.error("Message", "Activity with same name already exists.");
        } else {
          toastr.error("Message", "Error updating activity");
        }
        throw err;
      }
    },
    async deleteActivity(payload) {
      try {
        await initiativeActivitiesService.remove(payload.id);
        dispatch.initiatives.setSelectedActivityData({});
        dispatch.initiatives.getInDesignInitiativeDetailsById(
          payload.initiativeId
        );
      } catch (err) {
        toastr.error("Message", "Error deleting activity");
        throw err;
      }
    },

    async removeMapping(payload, state) {
      const community = await initiativeCommunitiesService.patch(payload, {
        $unset: { associatedTeam: "" },
      });
      dispatch.initiatives.updateCommunity({
        communityId: payload,
        teamId: null,
        initiativeId: community.initiativeId,
      });
      return;
    },
    async changeActivityIndex(payload) {
      await initiativeactivitiesDndService.create(payload);
    },
    initiativeAggangementPane(payload) {
      dispatch.initiatives.setinitiativeAggangementPane(payload);
    },
    async updateTotalWorkingDaysInInitiative(payload, state) {
      dispatch.initiatives.setWorkingDays(payload.workingDays);
      await initiativesService.patch(
        payload._id,
        {
          accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
          organizationId: state.initiatives.selectedDataById.organizationId, // KLM-9017
          $set: { workingDays: payload.workingDays }
        },
      );
    },
    async updateProgressForActivityInInitiative(payload, state) {
      await initiativeActivitiesService.patch(
        payload._id,
        {
          accountId: state.initiatives.selectedDataById.accountId,
          organizationId: state.initiatives.selectedDataById.organizationId,
        },
        { $set: { progress: payload.progress, triggerEvent: true } },
        {
          query: {
            $populate: [
              {
                path: "references.id",
                populate: "contentData",
                select: "_id name scope contentpath type",
              },
            ],
          },
        }
      );
    },
    async startActivityInInitiative(payload, state) {
      await initiativeActivitiesService.patch(
        payload._id,
        {
          accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
          organizationId: state.initiatives.selectedDataById.organizationId, // KLM-9017
        },
        { $set: payload.updateData, triggerEvent: true },
        {
          query: {
            $populate: [
              {
                path: "references.id",
                populate: "contentData",
                select: "_id name scope contentpath type",
              },
            ],
          },
        }
      );
    },
    addActivityModalOpen(onOffState) {
      dispatch.initiatives.setAddActivityModalOpen(onOffState);
    },
    copyActivityModalOpen(onOffState) {
      dispatch.initiatives.setCopyActivityModalOpen(onOffState);
    },
    isDurationSet(payload) {
      dispatch.initiatives.setIsDurationExist(payload);
    },

    setCurrntNotesAsync(payload) {
      dispatch.initiatives.setCurrntNotesData(payload);
    },

    async getActivityRACIUsersAsync(payload) {
      try {
        const RACIUserData = await activityRaciusersService.find({
          query: { id: payload },
        });
        dispatch.initiatives.setRACIUsers(RACIUserData);
      } catch (e) {
        throw e;
      }
    },
    async getSuborgByOrgId(payload) {
      const teamList = await subOrganizationService.find({
        query: {
          organizationId: payload.organizationId,
          createInitiative: true,
        },
      });
      dispatch.initiatives.setTeamList(teamList);
    },
    async startInitiative(payload) {
      await startInitiativeService.patch(payload._id, payload);
      dispatch.initiatives.getInDesignInitiativeDetailsById(payload._id);
    },
    async getAllActivities(payload, state) {
      let query = {
        $and: [{ initiativeId: payload.initiativeId }],
      };

      // :Filter on State
      if (
        state.initiatives.advancedFilterProperties.stateActiveChecked &&
        state.initiatives.advancedFilterProperties.stateOnHoldChecked
      ) {
      } else {
        if (state.initiatives.advancedFilterProperties.stateOnHoldChecked) {
          query.$and.push({
            onHoldFlag: true,
          });
        }

        if (state.initiatives.advancedFilterProperties.stateActiveChecked) {
          query.$and.push({
            onHoldFlag: false,
          });
        }
      }

      // :Filter on Status
      if (
        state.initiatives.advancedFilterProperties.statusNotStartedChecked ||
        state.initiatives.advancedFilterProperties.statusInProgressChecked ||
        state.initiatives.advancedFilterProperties.statusCompletedChecked ||
        state.initiatives.advancedFilterProperties.statusIssueChecked ||
        state.initiatives.advancedFilterProperties.statusDelayedChecked
      ) {
        let statusFilter = [];
        if (
          state.initiatives.advancedFilterProperties.statusNotStartedChecked
        ) {
          statusFilter.push({
            $and: [
              {
                $or: [{ runStatus: -1 }, { runStatus: 0 }],
              },
              { issueFlag: false },
            ],
          });
        }

        if (
          state.initiatives.advancedFilterProperties.statusInProgressChecked
        ) {
          statusFilter.push({
            $and: [{ runStatus: 1 }, { issueFlag: false }],
          });
        }

        if (state.initiatives.advancedFilterProperties.statusCompletedChecked) {
          statusFilter.push({
            $and: [{ runStatus: 2 }, { issueFlag: false }],
          });
        }

        if (state.initiatives.advancedFilterProperties.statusIssueChecked) {
          statusFilter.push({
            issueFlag: true,
          });
        }

        if (state.initiatives.advancedFilterProperties.statusDelayedChecked) {
          statusFilter.push({
            $or: [{ isDelayedToStart: true }, { isDelayedToEnd: true }],
          });
        }

        query.$and.push({
          $or: statusFilter,
        });
      }

      // : Filter on RACI
      if (
        state.initiatives.raciFilterProperties.responsible ||
        state.initiatives.raciFilterProperties.accountable ||
        state.initiatives.raciFilterProperties.consulted ||
        state.initiatives.raciFilterProperties.informed
      ) {
        let raciFilter = [];
        if (state.initiatives.raciFilterProperties.responsible) {
          raciFilter.push({
            "raci.r": { $elemMatch: { accountUserId: payload.accountUserId } },
          });
        }

        if (state.initiatives.raciFilterProperties.accountable) {
          raciFilter.push({
            "raci.a.accountUserId": payload.accountUserId,
          });
        }

        if (state.initiatives.raciFilterProperties.consulted) {
          raciFilter.push({
            "raci.c": { $elemMatch: { accountUserId: payload.accountUserId } },
          });
        }

        if (state.initiatives.raciFilterProperties.informed) {
          raciFilter.push({
            "raci.i": { $elemMatch: { accountUserId: payload.accountUserId } },
          });
        }

        query.$and.push({
          $or: raciFilter,
        });
      }

      if (state.initiatives.raciFilterProperties.myProgressChecked) {
        query.$and.push({
          $or: [
            {
              "raci.r": {
                $elemMatch: { accountUserId: payload.accountUserId },
              },
            },
            {
              "raci.a.accountUserId": payload.accountUserId,
            },
            {
              "raci.c": {
                $elemMatch: { accountUserId: payload.accountUserId },
              },
            },
            {
              "raci.i": {
                $elemMatch: { accountUserId: payload.accountUserId },
              },
            },
          ],
        });
      }

      if (
        state.initiatives.advancedFilterProperties.roles &&
        state.initiatives.advancedFilterProperties.roles.length > 0 &&
        state.initiatives.advancedFilterProperties.selectedUsers &&
        state.initiatives.advancedFilterProperties.selectedUsers.length > 0
      ) {
        query.$and.push({
          $or: [
            {
              $and: [
                {
                  "raci.r": {
                    $elemMatch: {
                      accountUserId: {
                        $in: state.initiatives.advancedFilterProperties
                          .selectedUsers,
                      },
                    },
                  },
                },
                {
                  "raci.r": {
                    $elemMatch: {
                      communityId: {
                        $in: state.initiatives.advancedFilterProperties.roles,
                      },
                    },
                  },
                },
              ],
            },
            {
              $and: [
                {
                  "raci.a.accountUserId": {
                    $in: state.initiatives.advancedFilterProperties
                      .selectedUsers,
                  },
                },
                {
                  "raci.a.communityId": {
                    $in: state.initiatives.advancedFilterProperties.roles,
                  },
                },
              ],
            },
            {
              $and: [
                {
                  "raci.c": {
                    $elemMatch: {
                      accountUserId: {
                        $in: state.initiatives.advancedFilterProperties
                          .selectedUsers,
                      },
                    },
                  },
                },
                {
                  "raci.c": {
                    $elemMatch: {
                      communityId: {
                        $in: state.initiatives.advancedFilterProperties.roles,
                      },
                    },
                  },
                },
              ],
            },
            {
              $and: [
                {
                  "raci.i": {
                    $elemMatch: {
                      accountUserId: {
                        $in: state.initiatives.advancedFilterProperties
                          .selectedUsers,
                      },
                    },
                  },
                },
                {
                  "raci.i": {
                    $elemMatch: {
                      communityId: {
                        $in: state.initiatives.advancedFilterProperties.roles,
                      },
                    },
                  },
                },
              ],
            },
          ],
        });
      } else {
        // :Filter on Role
        if (
          state.initiatives.advancedFilterProperties.roles &&
          state.initiatives.advancedFilterProperties.roles.length > 0
        ) {
          query.$and.push({
            $or: [
              {
                "raci.r": {
                  $elemMatch: {
                    communityId: {
                      $in: state.initiatives.advancedFilterProperties.roles,
                    },
                  },
                },
              },
              {
                "raci.a.communityId": {
                  $in: state.initiatives.advancedFilterProperties.roles,
                },
              },
              {
                "raci.c": {
                  $elemMatch: {
                    communityId: {
                      $in: state.initiatives.advancedFilterProperties.roles,
                    },
                  },
                },
              },
              {
                "raci.i": {
                  $elemMatch: {
                    communityId: {
                      $in: state.initiatives.advancedFilterProperties.roles,
                    },
                  },
                },
              },
            ],
          });
        }
        // :Filter on members
        if (
          state.initiatives.advancedFilterProperties.selectedUsers &&
          state.initiatives.advancedFilterProperties.selectedUsers.length > 0
        ) {
          query.$and.push({
            $or: [
              {
                "raci.r": {
                  $elemMatch: {
                    accountUserId: {
                      $in: state.initiatives.advancedFilterProperties
                        .selectedUsers,
                    },
                  },
                },
              },
              {
                "raci.a.accountUserId": {
                  $in: state.initiatives.advancedFilterProperties.selectedUsers,
                },
              },
              {
                "raci.c": {
                  $elemMatch: {
                    accountUserId: {
                      $in: state.initiatives.advancedFilterProperties
                        .selectedUsers,
                    },
                  },
                },
              },
              {
                "raci.i": {
                  $elemMatch: {
                    accountUserId: {
                      $in: state.initiatives.advancedFilterProperties
                        .selectedUsers,
                    },
                  },
                },
              },
            ],
          });
        }
      }
      const intiativeActivities = await initiativeLeafActivitiesService.find({
        query: query,
      });
      dispatch.initiatives.setActivityNodesArray(
        intiativeActivities.activityList
      );
      dispatch.initiatives.setRACICount(intiativeActivities.raciCount);
    },
    setGraph(payload) {
      dispatch.initiatives.setGraphData(payload);
    },
    setDepnendentNodesForActivity(payload) {
      dispatch.initiatives.setDepnendentNodesForActivityData(payload);
    },
    async updateInitiativeActivityDuration(payload, state) {
      dispatch.initiatives.updateActivityInSelectedDataById(payload);
      await initiativeActivitiesService.patch(
        payload._id,
        {
          accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
          organizationId: state.initiatives.selectedDataById.organizationId,// KLM-9017
          $set: {
            duration: payload.duration,
            isMilestone: payload.isMilestone,
            triggerEvent: true,
          },
          raciUpdated: true,
        },
        {
          query: {
            $populate: [
              {
                path: "references.id",
                populate: "contentData",
                select: "_id name scope contentpath type",
              },
            ],
          },
        }
      );
      dispatch.initiatives.getSelectedActivityDetails(payload._id);

      let isDurationSetAllActivities = true;
      const scanForActivitiesForDurationCheck = function (treeData) {
        treeData.forEach(function (treeNode) {
          if (
            treeNode.isLeafNode &&
            (!treeNode.duration || treeNode.duration === 0) &&
            !treeNode.isMilestone
          ) {
            isDurationSetAllActivities = false;
          }
          if (treeNode.activities) {
            scanForActivitiesForDurationCheck(treeNode.activities);
          }
        });
      };
      scanForActivitiesForDurationCheck(
        state.initiatives.selectedDataById.activities
      );
      dispatch.initiatives.isDurationSet(isDurationSetAllActivities);
    },

    updateActivityInSelectedDataById(payload, state) {
      delete payload.activities;
      let initiative = state.initiatives.selectedDataById;
      if (
        state.initiatives.selectedActivityData &&
        state.initiatives.selectedActivityData._id &&
        state.initiatives.selectedActivityData._id.toString() ===
          payload._id.toString()
      ) {
        dispatch.initiatives.getSelectedActivityDetails(payload._id);
      }
      if (payload.initiativeId) {
        let tempInitiativeId = payload.initiativeId._id
          ? payload.initiativeId._id
          : payload.initiativeId;
        if (
          state.initiatives.selectedDataById.sequenceViewMap &&
          initiative.activities &&
          initiative._id.toString() === tempInitiativeId.toString()
        ) {
          let activity = state.initiatives.selectedDataById.sequenceViewMap.get(
            payload._id
          );
          if (activity) {
            for (let key of Object.keys(payload)) {
              activity[key] = payload[key];
            }
            if (
              activity.isLeafNode &&
              (!activity.duration || activity.duration === 0) &&
              !activity.isMilestone
            ) {
              dispatch.initiatives.isDurationSet(false);
            }
            state.initiatives.selectedDataById.sequenceViewMap.set(
              activity._id,
              activity
            );
          }
        }

        if (initiative.activityNodes && initiative.activityNodes.length > 0) {
          for (let i = 0; i < initiative.activityNodes.length; i++) {
            if (
              initiative.activityNodes[i]._id.toString() ===
              payload._id.toString()
            ) {
              initiative.activityNodes[i] = Object.assign(
                initiative.activityNodes[i],
                payload
              );
              break;
            }
          }
        }
        if (initiative.communities) {
          let communityUpdate = {};
          for (let i = 0; i < initiative.communities.length; i++) {
            if (initiative.communities[i].communities) {
              for (
                let j = 0;
                j < initiative.communities[i].communities.length;
                j++
              ) {
                if (initiative.communities[i].communities[j].activities) {
                  for (
                    let k = 0;
                    k <
                    initiative.communities[i].communities[j].activities.length;
                    k++
                  ) {
                    if (
                      initiative.communities[i].communities[j].activities[
                        k
                      ]._id.toString() === payload._id.toString()
                    ) {
                      if (
                        payload.isSocket &&
                        initiative.communities[i].communities[j].activities[k]
                          .raci &&
                        initiative.communities[i].communities[j].activities[k]
                          .raci.a &&
                        initiative.communities[i].communities[j].activities[k]
                          .raci.a.communityId
                      ) {
                        if (
                          initiative.communities[i].communities[j].activities[
                            k
                          ].raci.a.communityId.toString() !==
                          payload.raci.a.communityId.toString()
                        ) {
                          communityUpdate.removeFromCommunity = initiative
                            .communities[i].communities[j].activities[k].raci.a
                            .communityId._id
                            ? initiative.communities[i].communities[j]
                                .activities[k].raci.a.communityId._id
                            : initiative.communities[i].communities[j]
                                .activities[k].raci.a.communityId;
                          communityUpdate.removeIndex = k;
                          communityUpdate.addInCommunity =
                            payload.raci.a.communityId;
                        }
                      }
                      initiative.communities[i].communities[j].activities[k] =
                        Object.assign(
                          initiative.communities[i].communities[j].activities[
                            k
                          ],
                          payload
                        );
                      if (payload.isSocket && communityUpdate !== {}) {
                        communityUpdate.activityToAdd =
                          initiative.communities[i].communities[j].activities[
                            k
                          ];
                      }
                    }
                  }
                }
              }
            }
          }
          if (
            payload.isSocket &&
            communityUpdate &&
            communityUpdate.removeFromCommunity
          ) {
            for (let i = 0; i < initiative.communities.length; i++) {
              for (
                let j = 0;
                j < initiative.communities[i].communities.length;
                j++
              ) {
                if (
                  initiative.communities[i].communities[j]._id.toString() ===
                  communityUpdate.removeFromCommunity.toString()
                ) {
                  if (
                    initiative.communities[i].communities[j]._id.toString() ===
                    communityUpdate.addInCommunity.toString()
                  ) {
                    initiative.communities[i].communities[j].activities.splice(
                      communityUpdate.removeIndex,
                      1,
                      communityUpdate.activityToAdd
                    );
                  } else {
                    initiative.communities[i].communities[j].activities.splice(
                      communityUpdate.removeIndex,
                      1
                    );
                  }
                } else if (
                  initiative.communities[i].communities[j]._id.toString() ===
                  communityUpdate.addInCommunity.toString()
                ) {
                  initiative.communities[i].communities[j].activities.push(
                    communityUpdate.activityToAdd
                  );
                }
              }
            }
            dispatch.initiatives.setSelectedDataById(
              Object.assign({}, initiative)
            );
          }
        }
        if (payload.progress && payload.progress > 0) {
          dispatch.initiatives.setSelectedDataById(initiative);
        }
        return;
      }
    },
    updateSelectedDataById(payload, state) {
      let initiative = Object.assign({}, state.initiatives.selectedDataById);
      if (
        initiative &&
        initiative._id &&
        payload._id &&
        initiative._id.toString() === payload._id.toString()
      ) {
        for (let key of Object.keys(payload)) {
          if (key !== "_id") {
            initiative[key] = payload[key];
          }
        }
      }

      dispatch.initiatives.setSelectedDataById(initiative);
    },
    async getTeamsUnderManager(payload) {
      const getTeamDropdown = function (orgUnits, teamArr, parent) {
        if (orgUnits) {
          for (const unit of orgUnits) {
            let teamName = parent ? parent + " > " + unit.label : unit.label;
            teamArr.push({ text: teamName, value: unit._id });
            if (unit.nodes) {
              getTeamDropdown(unit.nodes, teamArr, teamName);
            }
          }
          return teamArr;
        }
      };
      try {
        const orgUnits = await subOrganizationTreeService.get(payload.id);
        if (payload.teamlist === true) {
          let teamArr = [];
          let selectItem = {
            text: "Search Team",
            value: null,
          };
          let teamList = getTeamDropdown(orgUnits, teamArr, "");
          teamList.unshift(selectItem);

          dispatch.initiatives.setTeamList(teamList);
        } else {
          dispatch.initiatives.dispatchOrgUnits(orgUnits);
        }
      } catch (err) {
        throw err;
      }
    },

    addPhaseModalOpen(payload) {
      dispatch.initiatives.setAddPhaseModalOpen(payload);
    },
    setPeerActBtnDisable(payload) {
      dispatch.initiatives.setPeerActBtnStatus(payload);
    },
    async getCommunityWiseActivities(initiativeId, state) {
      let payload = {
        initiativeId: initiativeId,
        filterProperties: {
          raciAllChecked: state.initiatives.raciFilterProperties.raciAllChecked,
          accountable: state.initiatives.raciFilterProperties.accountable,
          responsible: state.initiatives.raciFilterProperties.responsible,
          consulted: state.initiatives.raciFilterProperties.consulted,
          informed: state.initiatives.raciFilterProperties.informed,
          roles: state.initiatives.advancedFilterProperties.roles,
          stateActiveChecked:
            state.initiatives.advancedFilterProperties.stateActiveChecked,
          stateOnHoldChecked:
            state.initiatives.advancedFilterProperties.stateOnHoldChecked,
          statusNotStartedChecked:
            state.initiatives.advancedFilterProperties.statusNotStartedChecked,
          statusCompletedChecked:
            state.initiatives.advancedFilterProperties.statusCompletedChecked,
          statusIssueChecked:
            state.initiatives.advancedFilterProperties.statusIssueChecked,
          statusInProgressChecked:
            state.initiatives.advancedFilterProperties.statusInProgressChecked,
          statusDelayedChecked:
            state.initiatives.advancedFilterProperties.statusDelayedChecked,
          selectedUsers:
            state.initiatives.advancedFilterProperties.selectedUsers,
        },
      };
      let communities = await activitiesGroupedByCommunitiesService.find({
        query: payload,
      });
      dispatch.initiatives.updateInitiativeCommunities(communities);
    },

    async getTeamDetailsOfActivity(payload) {
      let query = {
        teamId: payload.teamId,
        initiativeId: payload.initiativeId,
        createdBy: payload.createdBy,
        organizationId: payload.organizationId,
        string: "teamDetails",
      };
      try {
        const teamData = await subOrganizationService.find({ query: query });
        dispatch.initiatives.setTeamDetails(teamData);
      } catch (e) {
        throw e;
      }
    },
    updateInitiativeList(payload, state) {
      if (
        state.initiatives.intitiativeData &&
        state.initiatives.intitiativeData.data
      ) {
        for (let initiatives of state.initiatives.intitiativeData.data) {
          if (initiatives._id.toString() === payload._id.toString()) {
            for (let key of Object.keys(payload.data)) {
              initiatives[key] = payload.data[key];
            }

            break;
          }
        }
        dispatch.initiatives.setAllInitiatives(
          Object.assign({}, state.initiatives.intitiativeData)
        );
      }
    },
    setActivityObj(payload) {
      dispatch.initiatives.setNewActivityObj(payload);
    },
    setInitiativeDuration(payload) {
      dispatch.initiatives.setDuration(payload);
    },
    setInitiativeCycles(payload) {
      dispatch.initiatives.setCycles(payload.cycles);
    },
    setInitiativeStartEndDate(payload) {
      dispatch.initiatives.setStartEndDate(payload);
    },
    async getInitiativeActivitiesForMember(payload, state) {
      payload.raciAllChecked =
        state.initiatives.raciFilterProperties.raciAllChecked;
      payload.responsible = state.initiatives.raciFilterProperties.responsible;
      payload.accountable = state.initiatives.raciFilterProperties.accountable;
      payload.consulted = state.initiatives.raciFilterProperties.consulted;
      payload.informed = state.initiatives.raciFilterProperties.informed;
      payload.initiativeId = state.initiatives.initiativeId;
      payload.initiativeStatus = state.initiatives.activeStatus;
      payload.stateActiveChecked =
        state.initiatives.advancedFilterProperties.stateActiveChecked;
      payload.stateOnHoldChecked =
        state.initiatives.advancedFilterProperties.stateOnHoldChecked;
      payload.selectedUsers =
        state.initiatives.advancedFilterProperties.selectedUsers;
      const initiativeMemberActivities =
        await initiativeMemberActivitiesService.find({ query: payload });
      dispatch.initiatives.setInitiativeMemberActivities(
        initiativeMemberActivities
      );
      dispatch.initiatives.setRACICount(initiativeMemberActivities.raciCount);
      dispatch.initiatives.getInitiativesCountForMember({
        organizationId: payload.organizationId,
        userId: payload.userId,
        teamId: payload.teamId,
      });
    },
    setDependetMilestoneAct(payload) {
      dispatch.initiatives.setDependetMilestoneData(payload);
    },
    setLeafAct(payload) {
      dispatch.initiatives.setLeafActData(payload);
    },
    updateActivityInMyActivities(payload, state) {
      if (
        state.initiatives.initiativeMemberActivities.myActivities &&
        state.initiatives.initiativeMemberActivities.myActivities.length > 0
      ) {
        for (
          let i = 0;
          i < state.initiatives.initiativeMemberActivities.myActivities.length;
          i++
        ) {
          if (
            state.initiatives.initiativeMemberActivities.myActivities[
              i
            ]._id.toString() === payload._id.toString()
          ) {
            state.initiatives.initiativeMemberActivities.myActivities[i] =
              Object.assign(
                state.initiatives.initiativeMemberActivities.myActivities[i],
                payload
              );
            dispatch.initiatives.setInitiativeMemberActivities(
              state.initiatives.initiativeMemberActivities
            );
            break;
          }
        }
      }
    },

    async putActivitiesOnHold(activityId) {
      const dependentNodesToPutOnHold = await onHoldActivitiesService.get(
        activityId
      );
      dispatch.initiatives.setDepnendentNodesForActivityData(
        dependentNodesToPutOnHold
      );
    },

    async getInitiativesCountForMember(payload, state) {
      if (state.initiatives.activeTab === "myactivities") {
        const intiativesSummaryForMember =
          await initiativesCountByStatusForMemberService.find({
            query: payload,
          });
        dispatch.initiatives.setInitiativeCountsDataForMember(
          intiativesSummaryForMember
        );
      }
    },

    async getInitiativeOwnerDetails(accountUserId) {
      const intiativeOwner = await accountUsersService.get(accountUserId);
      dispatch.initiatives.setInitiativeOwnerDetails(intiativeOwner);
    },
    async getPlaybookOwnerDetails(accountUserId) {
      const playbookOwner = await accountUsersService.get(accountUserId);

      dispatch.initiatives.setPlaybookOwnerDetails(playbookOwner);
    },
    setIdToCenterPosition(payload) {
      dispatch.initiatives.setDBUniqueId(payload);
    },
    insertActivityInParent(payload, state) {
      if (
        state.initiatives.selectedDataById &&
        state.initiatives.selectedDataById.sequenceViewMap &&
        payload
      ) {
        state.initiatives.selectedDataById.sequenceViewMap.set(
          payload._id,
          payload
        );
      }
      if (
        state.initiatives.selectedDataById &&
        state.initiatives.selectedDataById._id
      ) {
        let initiative = Object.assign(state.initiatives.selectedDataById);
        if (initiative._id.toString() === payload.initiativeId.toString()) {
          if (!payload.parentActivity) {
            initiative.activities.push(payload);
          } else if (initiative.activities) {
            for (let i = 0; i < initiative.activities.length; i++) {
              if (
                initiative.activities[i]._id &&
                initiative.activities[i]._id.toString() ===
                  payload.parentActivity.toString()
              ) {
                initiative.activities[i].activities.push(payload);
                break;
              }
              if (initiative.activities[i].activities) {
                for (
                  let j = 0;
                  j < initiative.activities[i].activities.length;
                  j++
                ) {
                  if (
                    initiative.activities[i].activities[j]._id.toString() ===
                    payload.parentActivity.toString()
                  ) {
                    initiative.activities[i].activities[j].activities.push(
                      payload
                    );
                    break;
                  }
                }
              }
            }
          }
        }
        dispatch.initiatives.setSelectedDataById(Object.assign({}, initiative));
      }
    },
    splitAt(payload) {
      dispatch.initiatives.setSplitAtSize(payload);
    },
    checkForDeletedInitiative(payload, state) {
      if (state.app.currentContext === "initiative") {
        if (
          state.app.user._id.toString() !== payload.deletedBy.toString() &&
          state.initiatives.selectedDataById &&
          state.initiatives.selectedDataById._id &&
          state.initiatives.selectedDataById._id.toString() ===
            payload._id.toString()
        ) {
          toastr.error(
            "Message",
            `Initiative deleted by ${payload.deletedByName}`
          );
          dispatch.initiatives.getInitiatives(payload);
          dispatch.initiatives.getinitiativesCount(payload);
          dispatch.initiatives.showResourecePaneFlagSet(null);
          dispatch.initiatives.setSelectedDataById({});
          return dispatch(
            push(
              "/app/" +
                payload.organizationId +
                "/_ws/" +
                payload.organizationId +
                "/_in"
            )
          );
        } else if (state.initiatives.activeTab === "myactivities") {
          let filteredActivitiesList = {
            myActivities:
              state.initiatives.initiativeMemberActivities.myActivities.filter(
                (activity) => {
                  return (
                    activity.initiativeId.toString() !== payload._id.toString()
                  );
                }
              ),
          };
          if (
            filteredActivitiesList.myActivities.length !==
            state.initiatives.initiativeMemberActivities.myActivities.length
          ) {
            dispatch.initiatives.setInitiativeMemberActivities(
              filteredActivitiesList
            );
            toastr.success(
              "Message",
              `Initiative ${payload.name} deleted by ${payload.deletedByName}.`
            );
          }
        } else if (
          state.app.user._id.toString() !== payload.deletedBy.toString()
        ) {
          let filteredInitiativesList =
            state.initiatives.intitiativeData &&
            state.initiatives.intitiativeData.data &&
            state.initiatives.intitiativeData.data.filter((initiative) => {
              return initiative._id.toString() !== payload._id.toString();
            });
          if (
            filteredInitiativesList.length !==
            state.initiatives.intitiativeData.data.length
          ) {
            dispatch.initiatives.setAllInitiatives({
              data: filteredInitiativesList,
            });
            toastr.success(
              "Message",
              `Initiative ${payload.name} deleted by ${payload.deletedByName}.`
            );
          }
        }
      }
    },
    async assignAllRolesToTeam(payload) {
      let communitiesArray = [];
      payload.communities.forEach((community) => {
        community.communities.forEach((subCommunity) => {
          communitiesArray.push(subCommunity._id);
        });
      });
      try {
        await assignAllCommunitiesToOneTeamService.patch(payload.team, {
          initiativeId: payload.initiativeId,
        });
        await dispatch.initiatives.getInDesignInitiativeDetailsById(
          payload.initiativeId
        );
      } catch (e) {
        await dispatch.initiatives.getInDesignInitiativeDetailsById(
          payload.initiativeId
        );
      }
      return;
    },
    async copyTeamStructure(payload) {
      try {
        await copyTeamStructureService.create(payload);
        await dispatch.initiatives.getInDesignInitiativeDetailsById(
          payload.initiativeId
        );
      } catch (e) {
        if (e.code === 409) {
          toastr.error("Message", "Team with same name already exists");
        } else {
          toastr.error("Message", "Error while creating team");
        }
      }

      return;
    },
    updateCommunity(payload, state) {
      if (
        state.initiatives.selectedDataById &&
        state.initiatives.selectedDataById._id &&
        state.initiatives.selectedDataById._id.toString() ===
          payload.initiativeId.toString()
      ) {
        state.initiatives.selectedDataById.communities.forEach((community) => {
          community.communities.forEach((subCommunity) => {
            if (
              payload.communityId &&
              subCommunity._id.toString() === payload.communityId.toString()
            ) {
              if (!payload.assigningUser) {
                subCommunity.associatedTeam = payload.teamId;
              }

              if (payload.accountable) {
                subCommunity.accountable = payload.accountable;
              }
              if (payload.isRaciUpdated !== undefined) {
                subCommunity.isRaciUpdated = payload.isRaciUpdated;
              }
            }
          });
        });
      }
    },
    async setAccountableForCommunity(payload) {
      await initiativeCommunitiesService.patch(payload.communityId, {
        $set: { accountable: payload.accountUserId },
        isTeamMapping: true,
        option: payload.option,
      });
    },
    async setAccountableForCommunityProps(payload, state) {
      if(payload.communityId && payload.accountUser){
        for(let childCommunity of payload.childCommunities){
          if(childCommunity._id === payload.communityId){
            childCommunity.accountable = payload.accountUser;
          }
        }
      }
      dispatch.initiatives.setChildCommunities(payload.childCommunities)
    },
    updateActivityAction(payload) {
      dispatch.initiatives.addActivityAction(payload);
    },
    removeFromActivityAction(payload) {
      dispatch.initiatives.removeItemFromActivityAction(payload);
    },
    async removeAllDependenciesFromInitiative(payload, state) {
      await initiativeDependenciesService.remove(payload);
      await dispatch.initiatives.getInDesignInitiativeDetailsById(
        state.initiatives.selectedDataById._id
      );
      if (state.createPack.selectedPracticeFlowActivity._id) {
        await dispatch.initiatives.getSelectedActivityDetails(
          state.initiatives.selectedActivityData._id
        );
      }
    },
    async updateOrganizationusers(payload, state) {
      if (state.app.currentContext === "initiative") {
        if (
          payload.organizationId.toString() ===
            state.app.selectedOrganisation.id.toString() &&
          state.initiatives.selectedDataById &&
          state.initiatives.selectedDataById._id
        ) {
          if (state.initiatives.nodes && state.initiatives.nodes.length > 0) {
            let nodes = state.initiatives.nodes;
            let map = new Map();
            const traverseTeams = function (teams) {
              teams.forEach((team) => {
                map.set(team._id, team);
                if (team.nodes && team.nodes.length > 0) {
                  traverseTeams(team.nodes);
                }
              });
            };
            traverseTeams(nodes);

            if (Array.from(map.keys()).indexOf(payload._id) !== -1) {
              let teamData = map.get(payload._id);
              const checkIfAlreadyExist = (id) => {
                for (let i = 0; i < teamData.members.length; i++) {
                  if (
                    teamData.members[i].accountUserId.toString() ===
                    id.toString()
                  ) {
                    return true;
                  }
                }
                return false;
              };
              if (teamData.members.length < payload.members.length) {
                await payload.members.forEach(async (member) => {
                  if (!checkIfAlreadyExist(member.accountUserId)) {
                    let userData = await accountUsersService.get(
                      member.accountUserId
                    );
                    member.firstName = userData.firstName;
                    member.lastName = userData.lastName;
                    member.profilePic = userData.profilePic;
                    teamData.members.push(member);
                  }
                });
                map.set(payload._id, teamData);
                dispatch.initiatives.setOrgUnits(Object.assign([], nodes));
              }
            }
          }
        }
      }
    },
    updateInitiativeListAndCount(payload, state) {
      if (
        state.initiatives.activeTab &&
        state.initiatives.activeTab !== "myactivities"
      ) {
        if (
          state.app.selectedOrganisation.id &&
          state.app.selectedOrganisation.id.toString() ===
            payload.organizationId.toString()
        ) {
          dispatch.initiatives.getinitiativesCount({
            organizationId: payload.organizationId,
          });
          dispatch.initiatives.updateInitiativeList({
            _id: payload._id,
            data: payload,
          });
        }
      }
    },
    async getAllInitiativeByTeamId(payload) {
      let query = {
        organizationId: payload.organizationId,
        accountId: payload.accountId,
        teamId: payload.teamId,
      };
      const intiatives = await initiativesService.find({
        query: query,
      });
      dispatch.initiatives.setAllInitiativesByTeamId(intiatives);
    },
    setAllInitiativesByTeamId(payload) {
      dispatch.initiatives.setInitiativesByTeamId(payload);
    },
    async getAllInitiativeByUserIdAndTeamId(payload) {
      let query;
      if (payload.organizationId.toString() === payload.teamId.toString()) {
        query = {
          organizationId: payload.organizationId,
          accountId: payload.accountId,
          createdBy: payload.userId,
        };
      } else {
        query = {
          organizationId: payload.organizationId,
          accountId: payload.accountId,
          teamId: payload.teamId,
          createdBy: payload.userId,
        };
      }
      query.copyId = { $exists: false };
      const intiatives = await initiativesService.find({
        query: query,
      });
      dispatch.initiatives.setAllInitiativesByUserIdAndTeamId(intiatives);
    },
    setAllInitiativesByUserIdAndTeamId(payload) {
      dispatch.initiatives.setInitiativesByUserIdAndTeamId(payload);
    },
    updateSelectedActivity(payload, state) {
      if (
        state.initiatives.selectedActivityData &&
        state.initiatives.selectedActivityData._id &&
        payload.indexOf(
          state.initiatives.selectedActivityData._id.toString()
        ) !== -1
      ) {
        dispatch.initiatives.getSelectedActivityDetails(
          state.initiatives.selectedActivityData._id
        );
      }
    },
    updateRaciCount(payload, state) {
      if (payload.diff.hasOwnProperty(state.app.user._id.toString())) {
        let myData = payload.diff[state.app.user._id.toString()];
        if (
          state.initiatives.activeTab === "Progress" ||
          state.initiatives.activeTab === "Sequence" ||
          state.initiatives.activeTab === "Teams"
        ) {
          let currentInitiative = state.initiatives.selectedDataById._id;
          let activitiesForCurrentInitiative = myData.filter((data) => {
            return (
              data.initiativeId.toString() === currentInitiative.toString()
            );
          });
          if (activitiesForCurrentInitiative.length > 0) {
            let raciCount = state.initiatives.raciCount;
            activitiesForCurrentInitiative.forEach((activity) => {
              if (activity.action === "added") {
                raciCount[activity.type]++;
              }
              if (activity.action === "removed") {
                raciCount[activity.type]--;
              }
            });
            dispatch.initiatives.setRACICount(raciCount);
          }
        } else if (state.initiatives.activeTab === "myactivities") {
          let raciCount = state.initiatives.raciCount;
          myData.forEach((activity) => {
            if (activity.action === "added") {
              raciCount[activity.type]++;
            }
            if (activity.action === "removed") {
              raciCount[activity.type]--;
            }
          });
          dispatch.initiatives.setRACICount(raciCount);
        }
      }
    },
    updateInitaitiveDailyUpdates(payload, state) {
      initiativesService.patch(
        payload.id,
        {
          accountId: state.initiatives.selectedDataById.accountId,
          organizationId: state.initiatives.selectedDataById.organizationId, // KLM-9017
          dailyUpdates: payload.dailyUpdates,
        }
      );
    },
    async editInitiative(payload) {
      try {
        let copiedInitiative = await editInitiativeService.create(payload);
        dispatch.initiatives.getInDesignInitiativeDetailsById(
          copiedInitiative.newInitiativeId
        );
        dispatch.initiatives.getTeamMappingData({
          organizationId: copiedInitiative.organizationId,
          initiativeId: copiedInitiative.newInitiativeId,
          stopProcessing: () => {
            return false;
          },
          teamId: copiedInitiative.teamId,
        });
        return dispatch(
          push(
            "/app/" +
              payload.accountId +
              "/_ws/" +
              payload.organizationId +
              "/_in/indesign/teamMapping/" +
              copiedInitiative.newInitiativeId
          )
        );
      } catch (error) {
        toastr.error(
          "Message",
          'Error while moving the initiative in the "Edit" mode'
        );
      }
    },
    async cancelInitiativeEdit(payload) {
      try {
        let originalInitiative = await editInitiativeService.remove(payload);
        await dispatch.initiatives.getActiveInitiativeDetailsById(
          originalInitiative.initiativeId
        );
        await dispatch.initiatives.setSelectedActivityData({});
        await dispatch.initiatives.showResourecePane(null);
        await dispatch.lifeCycle.disableLinking();
        await dispatch.lifeCycle.setDependencyIcon(false);
        return dispatch(
          push(
            "/app/" +
              payload.accountId +
              "/_ws/" +
              payload.organizationId +
              "/_in/start/active/Progress/" +
              originalInitiative.initiativeId
          )
        );
      } catch (err) {
        throw err;
      }
    },
    async restartInitiative(payload) {
      const initiative = await restartInitiativeService.patch(
        payload._id,
        payload
      );
      dispatch.initiatives.getActiveInitiativeDetailsById(
        initiative.initiativeId
      );
    },
    async exportInitiative(payload) {
      const initiative = await exportInitiativeService.get(payload._id);
      var dataStr =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(initiative));
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(dataStr);
      } else {
        //for firfox/chrome
        let link = document.createElement("a");
        link.href = dataStr;
        link.download = payload.name + ".playbook";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    async routeWhenClickedInitiativeEdit(payload) {
      let isInitiativeRelated = false;
      if (
        payload.initiativesState.initiativeCountDataForMember &&
        payload.initiativesState.initiativeCountDataForMember
          .activeInitiatives &&
        payload.initiativesState.initiativeCountDataForMember.activeInitiatives
          .length > 0
      ) {
        let filteredInitiative =
          payload.initiativesState.initiativeCountDataForMember.activeInitiatives.filter(
            (initiative, i) => {
              return (
                initiative.id === payload.initiativeData.originalInitiativeId
              );
            }
          );
        if (filteredInitiative && filteredInitiative.length > 0) {
          isInitiativeRelated = true;
        }
      } else if (
        payload.initiativesState.intitiativeData &&
        payload.initiativesState.intitiativeData.data &&
        payload.initiativesState.intitiativeData.data.length > 0
      ) {
        let filteredInitiative =
          payload.initiativesState.intitiativeData.data.filter(
            (initiative, i) => {
              return (
                initiative._id === payload.initiativeData.originalInitiativeId
              );
            }
          );
        if (filteredInitiative && filteredInitiative.length > 0) {
          isInitiativeRelated = true;
        }
      }

      if (
        isInitiativeRelated == true &&
        payload.initiativeData.organizationId ==
          payload.appState.selectedOrganisation.id &&
        payload.appState.user._id != payload.userId
      ) {
        let message = (
          <div className="confirmMessage">
            <h3>Initiative</h3>
            <label>{payload.initiativeData.name}</label>
            <p>
              {payload.userName} has initiated edit for initiative{" "}
              {payload.initiativeData.name}
            </p>
          </div>
        );
        if (
          payload.appState.currentContext == "initiative" &&
          payload.routeParams.initiativeId ==
            payload.initiativeData.originalInitiativeId
        ) {
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
              await dispatch.lifeCycle.setArrangementPaneFlag(false);
              await dispatch.initiatives.initiativeAggangementPane(null);
              await dispatch.lifeCycle.disableLinking();
              await dispatch.app.showTeamListView(true);
              await dispatch.createPack.setSelectedActivityData({});
              await dispatch.lifeCycle.setSelectedPracticeLibraryData({});
              await dispatch.initiatives.setSelectedActivityData({});
              await dispatch.initiatives.setSelectedDataById({});
              return dispatch(
                push(
                  "/app/" +
                    payload.initiativeData.accountId +
                    "/_ws/" +
                    payload.initiativeData.organizationId +
                    "/_in"
                )
              );
            },
            disableCancel: true,
          });
        } else if (
          payload.appState.currentContext == "initiative" &&
          payload.routeParams.initiativeId !=
            payload.initiativeData.originalInitiativeId
        ) {
          let objectRouteParams = Object.getOwnPropertyNames(
            payload.routeParams
          );
          if (
            objectRouteParams.length == 2 &&
            objectRouteParams.includes("accountId") &&
            objectRouteParams.includes("workspaceId")
          ) {
            toastr.confirm(message, {
              onOk: async () => {
                await dispatch.initiatives.getInitiatives(
                  payload.initiativeData
                );
                await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
                await dispatch.initiatives.showResourecePane(null);
              },
              disableCancel: true,
            });
          }
        } else if (
          payload.appState.currentContext == "activities" &&
          payload.initiativesState.selectedDataById.copyId
        ) {
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.setInitiativeId(
                payload.initiativesState.selectedDataById.copyId
              );
              await dispatch.initiatives.getActiveInitiativeDetailsById({
                initiativeId: payload.initiativesState.selectedDataById.copyId,
                isMemberView: true,
              });
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
              return dispatch(
                push(
                  "/app/" +
                    (payload.routeParams.accountId
                      ? payload.routeParams.accountId
                      : payload.appState.selectedAccount._id) +
                    "/_ws/" +
                    (payload.routeParams.workspaceId
                      ? payload.routeParams.workspaceId
                      : payload.appState.selectedOrganisation._id) +
                    "/_at/myactivities/activeInitiatives/" +
                    payload.initiativesState.selectedDataById.copyId
                )
              );
            },
            disableCancel: true,
          });
        } else if (payload.appState.currentContext == "activities") {
          let objectRequiredToFetchAllInitiativeActivitiesForMember = {
            accountId: payload.initiativeData.accountId,
            organizationId: payload.initiativeData.organizationId,
            userId: payload.appState.user._id,
          };

          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.getInitiativeActivitiesForMember(
                objectRequiredToFetchAllInitiativeActivitiesForMember
              );
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
            },
            disableCancel: true,
          });
        }
      }
    },
    async routeAftercancelInitiativeEdit(payload) {
      let isInitiativeRelated = false;
      if (
        payload.initiativesState.initiativeCountDataForMember &&
        payload.initiativesState.initiativeCountDataForMember
          .activeInitiatives &&
        payload.initiativesState.initiativeCountDataForMember.activeInitiatives
          .length > 0
      ) {
        let filteredInitiative =
          payload.initiativesState.initiativeCountDataForMember.activeInitiatives.filter(
            (initiative, i) => {
              return initiative.id === payload.initiativeData.copyId;
            }
          );
        if (filteredInitiative && filteredInitiative.length > 0) {
          isInitiativeRelated = true;
        }
      } else if (
        payload.initiativesState.intitiativeData &&
        payload.initiativesState.intitiativeData.data &&
        payload.initiativesState.intitiativeData.data.length > 0
      ) {
        let filteredInitiative =
          payload.initiativesState.intitiativeData.data.filter(
            (initiative, i) => {
              return initiative._id === payload.initiativeData.copyId;
            }
          );
        if (filteredInitiative && filteredInitiative.length > 0) {
          isInitiativeRelated = true;
        }
      } else if (
        payload &&
        payload.appState &&
        payload.appState.helpContext == "Edit Initative"
      ) {
        if (
          payload.appState.selectedOrganisation &&
          payload.appState.selectedOrganisation.role == "workspaceOwner" &&
          payload.routeParams.initiativeId == payload.initiativeData.copyId
        ) {
          isInitiativeRelated = true;
        }
      }
      if (
        isInitiativeRelated == true &&
        payload.initiativeData.organizationId ==
          payload.appState.selectedOrganisation.id &&
        payload.appState.user._id != payload.userId
      ) {
        let message = (
          <div className="confirmMessage">
            <h3>Initiative</h3>
            <label>{payload.initiativeData.name}</label>
            <p>
              The editing for the initiative {payload.initiativeData.name} has
              been cancelled by {payload.userName}
            </p>
          </div>
        );
        if (
          payload.appState.currentContext == "initiative" &&
          payload.routeParams.initiativeId == payload.initiativeData._id
        ) {
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.getActiveInitiativeDetailsById(
                payload.initiativeData._id
              );
              await dispatch.initiatives.setSelectedActivityData({});
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
              return dispatch(
                push(
                  "/app/" +
                    payload.initiativeData.accountId +
                    "/_ws/" +
                    "/_in/start/active/Progress/" +
                    payload.initiativeData._id
                )
              );
            },
            disableCancel: true,
          });
        } else if (
          payload.appState.currentContext == "initiative" &&
          payload.routeParams.initiativeId != payload.initiativeData._id
        ) {
          let objectRouteParams = Object.getOwnPropertyNames(
            payload.routeParams
          );
          if (
            objectRouteParams.length == 2 &&
            objectRouteParams.includes("accountId") &&
            objectRouteParams.includes("workspaceId")
          ) {
            toastr.confirm(message, {
              onOk: async () => {
                await dispatch.initiatives.getInitiatives(
                  payload.initiativeData
                );
                await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
                await dispatch.initiatives.showResourecePane(null);
              },
              disableCancel: true,
            });
          } else if (
            payload.routeParams.initiativeId == payload.initiativeData.copyId
          ) {
            toastr.confirm(message, {
              onOk: async () => {
                await dispatch.initiatives.getActiveInitiativeDetailsById(
                  payload.initiativeData._id
                );
                await dispatch.initiatives.setSelectedActivityData({});
                await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
                await dispatch.initiatives.showResourecePane(null);
                return dispatch(
                  push(
                    "/app/" +
                      payload.initiativeData.accountId +
                      "/_ws/" +
                      payload.initiativeData.organizationId +
                      "/_in/start/active/Progress/" +
                      payload.initiativeData._id
                  )
                );
              },
              disableCancel: true,
            });
          }
        } else if (
          payload.appState.currentContext == "activities" &&
          payload.initiativesState.selectedDataById.originalInitiativeId
        ) {
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.setInitiativeId(
                payload.initiativesState.selectedDataById.originalInitiativeId
              );
              await dispatch.initiatives.getActiveInitiativeDetailsById({
                initiativeId:
                  payload.initiativesState.selectedDataById
                    .originalInitiativeId,
                isMemberView: true,
              });
              await dispatch.initiatives.setPageStatus(null);
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
              await dispatch.initiatives.setIdToCenterPosition(null);
              await dispatch.initiatives.setSelectedActivityData({});
              return dispatch(
                push(
                  "/app/" +
                    payload.routeParams.accountId +
                    "/_ws/" +
                    payload.routeParams.workspaceId +
                    "/_at/myactivities/activeInitiatives/" +
                    payload.initiativesState.selectedDataById
                      .originalInitiativeId
                )
              );
            },
            disableCancel: true,
          });
        } else if (payload.appState.currentContext == "activities") {
          let objectRequiredToFetchAllInitiativeActivitiesForMember = {
            accountId: payload.initiativeData.accountId,
            organizationId: payload.initiativeData.organizationId,
            userId: payload.appState.user._id,
          };
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.getInitiativeActivitiesForMember(
                objectRequiredToFetchAllInitiativeActivitiesForMember
              );
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
            },
            disableCancel: true,
          });
        }
      }
    },
    async routeAfterInitiativeEditCompletedOrRestartInitiative(payload) {
      let isInitiativeRelated = false;
      if (
        payload.initiativesState.initiativeCountDataForMember &&
        payload.initiativesState.initiativeCountDataForMember
          .activeInitiatives &&
        payload.initiativesState.initiativeCountDataForMember.activeInitiatives
          .length > 0
      ) {
        let filteredInitiative =
          payload.initiativesState.initiativeCountDataForMember.activeInitiatives.filter(
            (initiative, i) => {
              return initiative.id === payload.initiativeData._id;
            }
          );
        if (filteredInitiative && filteredInitiative.length > 0) {
          isInitiativeRelated = true;
        } else {
          let filteredInitiative =
            payload.initiativesState.initiativeCountDataForMember.activeInitiatives.filter(
              (initiative, i) => {
                return initiative.id === payload.copyId;
              }
            );
          if (filteredInitiative && filteredInitiative.length > 0) {
            isInitiativeRelated = true;
          }
        }
      } else if (
        payload.initiativesState.intitiativeData &&
        payload.initiativesState.intitiativeData.data &&
        payload.initiativesState.intitiativeData.data.length > 0
      ) {
        let filteredInitiative =
          payload.initiativesState.intitiativeData.data.filter(
            (initiative, i) => {
              return initiative._id === payload.initiativeData._id;
            }
          );
        if (filteredInitiative && filteredInitiative.length > 0) {
          isInitiativeRelated = true;
        }
      }
      if (
        isInitiativeRelated == true &&
        payload.initiativeData.organizationId ==
          payload.appState.selectedOrganisation.id &&
        payload.appState.user._id != payload.userId
      ) {
        let message = (
          <div className="confirmMessage">
            <h3>Initiative</h3>
            <label>{payload.initiativeData.name}</label>
            <p>
              The editing for the initiative {payload.initiativeData.name} has
              been completed by {payload.userName}
            </p>
          </div>
        );
        if (
          payload.appState.currentContext == "initiative" &&
          payload.routeParams.initiativeId == payload.copyId
        ) {
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.getActiveInitiativeDetailsById(
                payload.initiativeData._id
              );
              await dispatch.initiatives.setSelectedActivityData({});
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
              return dispatch(
                push(
                  "/app/" +
                    payload.initiativeData.accountId +
                    "/_ws/" +
                    payload.initiativeData.organizationId +
                    "/_in/start/active/Progress/" +
                    payload.initiativeData._id
                )
              );
            },
            disableCancel: true,
          });
        } else if (payload.appState.currentContext == "initiative") {
          let objectRouteParams = Object.getOwnPropertyNames(
            payload.routeParams
          );
          toastr.confirm(message, {
            onOk: async () => {
              if (
                objectRouteParams.length == 2 &&
                objectRouteParams.includes("accountId") &&
                objectRouteParams.includes("workspaceId")
              ) {
                await dispatch.initiatives.getInitiatives(
                  payload.initiativeData
                );
                await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
                await dispatch.initiatives.showResourecePane(null);
              }
            },
            disableCancel: true,
          });
        } else if (
          payload.appState.currentContext == "activities" &&
          payload.initiativesState.selectedDataById.originalInitiativeId
        ) {
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.setInitiativeId(
                payload.initiativesState.selectedDataById.originalInitiativeId
              );
              await dispatch.initiatives.getActiveInitiativeDetailsById({
                initiativeId:
                  payload.initiativesState.selectedDataById
                    .originalInitiativeId,
                isMemberView: true,
              });
              await dispatch.initiatives.setPageStatus(null);
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
              await dispatch.initiatives.setIdToCenterPosition(null);
              await dispatch.initiatives.setSelectedActivityData({});
              return dispatch(
                push(
                  "/app/" +
                    payload.routeParams.accountId +
                    "/_ws/" +
                    payload.routeParams.workspaceId +
                    "/_at/myactivities/activeInitiatives/" +
                    payload.initiativesState.selectedDataById
                      .originalInitiativeId
                )
              );
            },
            disableCancel: true,
          });
        } else if (payload.appState.currentContext == "activities") {
          let objectRequiredToFetchAllInitiativeActivitiesForMember = {
            accountId: payload.initiativeData.accountId,
            organizationId: payload.initiativeData.organizationId,
            userId: payload.appState.user._id,
          };
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.getInitiativeActivitiesForMember(
                objectRequiredToFetchAllInitiativeActivitiesForMember
              );
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
            },
            disableCancel: true,
          });
        }
      }
    },
    async routeAfterDeletingInitiative(payload) {
      if (
        payload.initiativeData.organizationId ==
          payload.appState.selectedOrganisation.id &&
        payload.appState.user._id != payload.userId
      ) {
        let message = (
          <div className="confirmMessage">
            <h3>Initiative</h3>
            <label>{payload.initiativeData.name}</label>
            <p>
              The initiative {payload.initiativeData.name} has been deleted by{" "}
              {payload.userName}
            </p>
          </div>
        );
        if (
          payload.appState.currentContext == "initiative" &&
          payload.routeParams.initiativeId == payload._id
        ) {
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.getInitiatives(payload.initiativeData);
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
            },
            disableCancel: true,
          });
        } else if (payload.appState.currentContext == "activities") {
          let objectRequiredToFetchAllInitiativeActivitiesForMember = {
            accountId: payload.initiativeData.accountId,
            organizationId: payload.initiativeData.organizationId,
            userId: payload.appState.user._id,
          };
          toastr.confirm(message, {
            onOk: async () => {
              await dispatch.initiatives.getInitiativeActivitiesForMember(
                objectRequiredToFetchAllInitiativeActivitiesForMember
              );
              await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
              await dispatch.initiatives.showResourecePane(null);
            },
            disableCancel: true,
          });
        }
      }
    },
    async changeStageSequenceDragDrop(payoad, state) {
      try {
        if (
          state &&
          state.initiatives &&
          state.initiatives.selectedDataById &&
          state.initiatives.selectedDataById.activities &&
          state.initiatives.selectedDataById.activities.length > 0
        ) {
          let phaseActivities = state.initiatives.selectedDataById.activities;
          for (var [i, phaseActivity] of phaseActivities.entries()) {
            if (
              phaseActivity &&
              phaseActivity._id.toString() ==
                payoad.parentActivity.toString() &&
              phaseActivity.activities &&
              phaseActivity.activities.length > 0
            ) {
              let sourceIndex = phaseActivity.activities.findIndex(
                (element) => element._id == payoad.sourceId
              );
              let targetIndex = phaseActivity.activities.findIndex(
                (element) => element._id == payoad.targetId
              );
              let sourceActivity = phaseActivity.activities[sourceIndex];
              if (sourceIndex > targetIndex) {
                phaseActivity.activities.splice(targetIndex, 0, sourceActivity);
                phaseActivity.activities.splice(sourceIndex + 1, 1);
              }
              if (sourceIndex < targetIndex) {
                phaseActivity.activities.splice(
                  targetIndex + 1,
                  0,
                  sourceActivity
                );
                phaseActivity.activities.splice(sourceIndex, 1);
              }
              let activitiesToUpdate = phaseActivity.activities.map(
                (activity) => {
                  return activity._id;
                }
              );
              await initiativeActivitiesService.patch(
                phaseActivity._id,
                {
                  accountId: state.initiatives.selectedDataById.accountId, // KLM-9017
                  organizationId:
                    state.initiatives.selectedDataById.organizationId, // KLM-9017
                },
                {
                  $set: {
                    activities: activitiesToUpdate,
                  },
                }
              );
            }
          }
        }
        dispatch.initiatives.setSelectedDataById(
          Object.assign({}, state.initiatives.selectedDataById)
        );
      } catch (error) {
        throw error;
      }
    },
    async copyActivity(selectedActivity, state) {
      try {
        dispatch.initiatives.setLoader(true);
        let createdActivity = await copyActivityService.create(
          selectedActivity
        );
        await dispatch.initiatives.getInDesignInitiativeDetailsById(
          createdActivity.initiativeId
        );
        dispatch.initiatives.setLoader(false);
      } catch (error) {
        dispatch.initiatives.setLoader(false);
        throw error;
      }
    },
  },
};
